//import "./Isilog.vars.js";
import { IsiBc } from "../../IsiActiveBusiness/IsiBc";
import { IsiRedirectJs } from "../../basic";
import { IIsiDtoAutoRefreshSettings, IIsiDtoIwsUI, IIsiDtoIwsUIScreen, IIsiDtoMenuObject, IsiDtoAssociatedViewManagerClientState, IsiDtoAutoRefreshSettings, IsiDtoIwsUI, IsiDtoIwsUIClientState } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject";
import { IsiCallerType } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlSuggest";
import { IIsiDtoGLOBXXXOpenArgs, IsiDtoGLOB068OpenArgs, IsiDtoGLOB069OpenArgs } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPopins";
import { IIsiDataTransferObject, IsiDataTransferObject } from "../../Dtos/Isilog.IsiFramework.IsiDataTransferObject";
import "../../IsiAntiCsrf";
import "../../IsiControlesNames";
import { IsiItemList } from "../../IsiItemList";
import "../../Isilog.consts";
import "../../Isilog.enums";
import { IsiButtonType, IsiIconType, IsiMessageMode, IsiModeConfirm, IsiScreenType, IsiUseContext, MenuItemCode } from "../../Isilog.enums";
import { getPl } from "../../Isilog.pls";
import { getPopin, getPopinArgs, GLOB068, GLOB069, IsiGenDialog } from "../../Isilog.popins";
import * as screens from "../../Isilog.screens";
import { appendSessionId, GetWaitStatus, iws_GetDisplayedAssociatedViewName, modifWaitStatus, setShortCutStatus } from "../../IsiPage.ts";
import { IsiPerformance } from "../../IsiPerformance";
import { IsiIwsElasticSearch } from "../../IsiWebGUI/Components/ElasticSearch/IsiIwsElasticSearch.component";
import { addOrReplaceParamToUrl } from "../../IsiWebGUI/core.ts";
import { IsiPopinTooltipInitializer } from "../../IsiWebGUI/IsiFW/Components/Generics/IsiPopinTooltipInitializer";
import { IsiComponentManager } from "../../IsiWebGUI/IsiFW/Core/Manager/IsiComponentManager";
import { IIsiPopInSettingsConstructorArgs } from "../../IsiWebGUI/IsiFW/Core/Popin/IIsiPopInSettingsConstructorArgs";
import { IIsiPopInSettingsOpenSettings } from "../../IsiWebGUI/IsiFW/Core/Popin/IIsiPopInSettingsOpenSettings";
import { IsiPopInSettings, IsiUICore } from "../../IsiWebGUI/IsiFW/IsiFW.ui.core";
import { Menu_BeforeItemSelected } from "../../menu.ts";
import "../../message.ts";
import { isiGetClientHeight, isiGetClientWidth, iws_stopPropagation } from "../../tools.ts";
import { EVENT_AFTER_CALC_VAL_DEF } from "../../Xml/XmlUserSettings";
import { IsiActionContext } from "../Core/IsiActionContext";
import { IsiInteraction } from "../Core/IsiInteraction";
import { ControlTypes } from "../Form/Controls/IsiControlTypes";
import { IsiFormManager } from "../Form/IsiFormManager";
import { IsiGridDragNDropManager } from "../Grid/DragNDrop/IsiGridDragNDropManager";
import { IsiIWSAssociatedView } from "../GridView/AssociatedView/IsiAssociatedView";
import { IsiDetailManager } from "../GridView/AssociatedView/IsiAssociatedViewManager";
import { IsiIWSAssociatedViewContext } from "../GridView/AssociatedView/IsiIwsAssociatedViewContext";
import { IsiGridManagerNewGrid } from "../GridView/IsiGridManagerNewGrid";
import { IsiMenuManager } from "../Menu/IsiMenuManager";
import { IsiPlAttPreview } from "../PresentationLogic/IsiPlAttPreview";
import { IsiPlCheckDateFormat } from "../PresentationLogic/IsiPlCheckDateFormat";
import { IsiPlInstanceScreen } from "../PresentationLogic/IsiPlInstanceScreen";
import { IsiPlPopin } from "../PresentationLogic/IsiPlPopin";
import { IsiPresentationLogic } from "../PresentationLogic/IsiPresentationLogic";
import { IsiActionRedirect } from "../UI/IsiActionRedirect";
import { IsiCia } from "../UI/IsiCia";
import { IsiConfirmation } from "../UI/IsiConfirmation";
import { IIsiUIFlowResult } from "./IIsiUIFlowResult";
import { IsiAutoRefresh } from "./IsiAutoRefresh";
import { IsiDomStructure } from "./IsiStructure";
import { IsiUIFlowRejectReason } from "./IsiUIFlowRejectReason";

declare function IsEntryOnlyJokers(value: string): string;
declare function isiPostBack(eventTarget: string, eventArgument: any);

export class IsiIwsUICore extends IsiUICore<IsiIwsUICore> {

    private _currentAssociatedViewDockedBar;
    private _currentActionContext: IsiActionContext;
    private _positionMouseX: number;
    private _positionMouseY: number;
    private _disableAutoWaitStatusOnBeforeUnload: boolean;
    private _businessRulesRunning: string[];
    private _needCheckBusinessRuleRunning: boolean = true;
    private _submitPending: boolean;
    private _submitPendingActionContext: IsiActionContext;
    public cnxChangingValue: boolean;
    public blockCnxProp: boolean;

   /**
   *  Méthode à surcharger pour définir l'url utilisé 
   *  pour effectuer le test de disponibilité du sever
   * @returns la dite url
   */
    _testConnexionUrlOverridable() {
        const publicPath: string =this.getOptions()?.webpackPublicPath ?? '';
        const url = new URL(publicPath || window.location.href);
        const appRoot = url.pathname.split('/').filter(Boolean)[0];
        return `/${appRoot}/testConnexion.json`;
    }

    /**
     * echappe une chaine de caractère
     * @param text
     */
    public xssEscape(text: string): string {
        return jQuery("<div></div>").text(text).html();
    }

    /**
     * Lance l'affichage d'une demande de confirmation
     * @param options
     * @returns
     */
    _showConfirmNoIframeOverridable(options) {

        const pop = this.getIsiPopin();

        pop.resetDefaultSettings();
        pop.addCustomClass("IsiConfirmPopin");
        if (options.addtionalClass) {
            pop.addCustomClass(options.addtionalClass);
        }
        pop.updateDtoProperty("upperBarTitle", this.getMessage("POPIN", "TitreConfirmation").IsiLabel);


        pop.updateDtoProperty("contentContainerVerticalPositionning", "middle");
        pop.getExternalContentContainer().html(options.message);
        pop.setBottomBarButtons({
            template: pop.BOTTOMBAR_BUTTONS_TEMPLATE.VALIDATE,
            onClickHandler: () => {
                options.ok();

            }
        }, {
            template: pop.BOTTOMBAR_BUTTONS_TEMPLATE.CANCEL,
            onClickHandler: () => {
                options.cancel();
            }
        });
        pop.RemoveCloseOnVeilClick();
        pop.refreshElements();
        pop.show();
        return true;
    }

    _showConfirmOverridable(options) {
        if (options?.noIframe) {
            this._showConfirmNoIframeOverridable(options);
        } else {
            this._showConfirmIframeOverridable(options);
        }
    }

    _showConfirmIframeOverridable(options) {
        var callbackTreatmentArgs = options.callback || null;
        options = options || {};

        uiCore.addUITreatment({
            if: options.if,
            func: function (options) {
                let popinOptions;
                let mustEchapHtml = 0;
                if (options.mustEchapHtml !== undefined) {
                    mustEchapHtml = 1;
                }

                const msg = options.message || false;
                const iconType = options.iconType || IsiIconType.Question;
                const modeConfirm = options.confirmMode || IsiModeConfirm.ValidateCancel;
                const width = 468;
                const height = "auto";
                const resizeToFitContent = true;
                // Ratio Largeur/Hauteur à respecter (si possible), val par défaut : 3
                const widthToHeightRatio = options.widthToHeightRatio || 3;
                const title = options.title || '';
                const mainClassName = options.mainClassName || '';

                // on affiche la popup que si on a un message
                if (msg) {
                    //Dysf75191
                    const treatmentId = options.treatmentId || "popin " + msg;

                    popinOptions = {
                        width: width,
                        height: height,
                        callback: function (key) {
                            return function (result) { uiCore._uiTreatmentEngine.unblockTreatment(key, result) };
                        }(msg),
                        number: options.number,
                        numberOf: options.numberOf,
                        treatmentId: treatmentId,
                        resizeToFitContent: resizeToFitContent,
                        widthToHeightRatio: widthToHeightRatio
                    };

                    IsiGenDialog().open([msg, title, modeConfirm, iconType, height, width, IsiMessageMode.ClassicMode, mustEchapHtml, mainClassName], popinOptions);
                }
            },
            args: [options],
            id: options.message,
            blocking: true,
            callback: {
                func: function (result) {
                    if (result) {
                        return result[0];
                    }
                },
                id: "_showConfirmOverridable core callback for " + options.message,
                callback: callbackTreatmentArgs
            }
        });
    }

    _CheckCompulsoryFieldsOverridable(args) {
        // CLEM - DYSF75126 - pb sur l action numeriser et la maj des champs sur adm056
        return !this._currentScreen.CheckCompulsoryFieldsForScreen(args) || iwsAllCtrls.CheckCompulsoryFields();
    }

    /**
     * Vérifie que les champs traduits sont bien renseignés
     * @param args
     * @returns
     */
    _CheckTranslatedFieldsOverridable(args) {
        return iwsAllCtrls.CheckTranslatedFields();
    }

    /**
     * Retourne l'objet IsiPlAttPreview
     * */
    getAttPreviewPL() {
        return new IsiPlAttPreview();
    }
    /**
     * retourne le pl de nom demandé.
     * utile lorsque l'appelant ne peut pas être migré du js => ts.
     * */
    getPl(name: string): Promise<IsiPresentationLogic> {
        return new Promise((resolve: (pl: IsiPresentationLogic) => void, reject): void => {
            getPl(name).then((pl) => {
                resolve(pl);
            })
        });
    }

    /**
     * Permet d'obtenir le composant ElasticSearch
     * @returns L'instance courante de IsiIwsElasticSearch
     */
    getElasticComponent(): any {
        return this.componentManager?.getComponent("elasticBtn_search");
    }

    /**
     * AUTEUR       : ARAN
     * DESCRIPTION  : [T144883]IsiColorSelector
     */
    get colorSelector(): any {
        return this.componentManager?.getComponent("IsiColorSelector");
    }

    /**
    * Evenement levé lors de la création du bouton de switch de mode entre souris et tactile. 
    * Bind le bouton à sa fonctionnalité.
    **/
    _bindSwitchMode() {
        //On récupère le bouton du switch de mode tactile
        var pSwitchBtn = this.componentManager.getComponent<any>("SwitchModeBtn");
        if (!pSwitchBtn) return;
        // On bind le clic sur le traitement de changement de mode souris/tactile
        pSwitchBtn.add_onValueChanged(function (me) {
            return function () {
                var url;
                // set le DesktopTouchMode à l'inverse de sa valeur actuelle
                me._isDesktopTouchMode = !me._isDesktopTouchMode;

                // On stock le desktopTouchMode dans le dtoClient
                me.getClient().DesktopTouchMode = me._isDesktopTouchMode;

                // On stock le desktopTouchMode dans le localStorage
                me.setLocalStorageItem('desktopTouchMode', me._isDesktopTouchMode);

                // Si l'écran doit passer en tactile
                if (me._isDesktopTouchMode) {
                    //On envoie au serveur la valeur touchmode = 1
                    url = addOrReplaceParamToUrl(jQuery(location).attr("href"), "touchmode", "1");
                    IsiRedirectJs(url)
                } else {
                    // Sinon on envoie touchmode = 0
                    url = addOrReplaceParamToUrl(jQuery(location).attr("href"), "touchmode", "0");
                    IsiRedirectJs(url)
                }

            }
        }(this));
    }

    /**
    * Fonction appelée sur la Homepage permettant de vérifier l'état du desktopTouchMode présent dans 
    * le localStorage. Renvoie ensuite cette valeur dans le dtoClient.
    **/
    setTouchModeFromLocalStorage() {
        if (uiCore.getLocalStorageItem('desktopTouchMode')) {
            uiCore.getClient().DesktopTouchMode = uiCore.getLocalStorageItem('desktopTouchMode');
        }
    }

    _showMessageOverridable(msg, options) {
        uiCore.addUITreatment({
            func: function (msg, options) {
                let mustEchapHtml = 0;
                if (options.mustEchapHtml !== undefined) {
                    mustEchapHtml = 1;
                }


                if (!options.mode) {
                    options.mode = IsiMessageMode.ClassicMode;
                } else {
                    if (options.mode == IsiMessageMode.SessionMode) {
                        options.popin = true;
                    };
                }

                if (options.error && !options.iconType) {
                    options.iconType = IsiIconType.Errors;
                } else if (!options.iconType) {
                    options.iconType = IsiIconType.Information;
                }
                const width = options.width || 468; // on tient compte des options données
                const height = options.height || "auto";// on tient compte des options données

                const resizeToFitContent = (options.resizeToFitContent === undefined) ? true : options.resizeToFitContent;
                const title = options.title || '';
                // Ratio Largeur/Hauteur à respecter (si possible), val par défaut : 2
                const widthToHeightRatio = options.widthToHeightRatio || 2;
                const mainClassName = options.mainClassName || '';

                IsiGenDialog().open([msg, title, IsiModeConfirm.OkOnly, options.iconType, height, width, options.mode, mustEchapHtml, mainClassName], {
                    width: width,
                    height: height,
                    blocking: true,
                    callback: options.callback,
                    resizeToFitContent: resizeToFitContent,
                    widthToHeightRatio: widthToHeightRatio
                });
            },
            args: [msg, options],
            id: msg,
            isAlert: true
        });
    }



    /**
     * Méthode noyau surchargeable systématiquement appelée après la fermeture d'une popin
     * @param {IsiPopInSettings} popin L'objet associé à la popin
     * @returns boolean
     */
    _afterClosePopinOverridable(popin) {
        // Apres fermeture de la popin, le focus est remis dans l'application sinon il est naturellement au niveau du navigateur
        // et les raccourcis clavier ne fonctionnent plus
        var banner = document.getElementById(DIV_BANNER);
        if (banner) {
            banner.focus();
        }
        execUserModalChoice(popin);
        return true;
    }
    /**
    * Retourne l'identifiant du composant Popin surchargé dans les produits.
    */
    _getPopInCmpIdOverriadable() {
        return 'isiPopin';
    }

    _reloadPageOverridable() {
        screenCore.onClick(null, MNU_MASTER + MNU_SEP + FORM_MNUGRP_NAVIGATION + MNU_SEP + FORM_REFRESH);
    }
    _isHomepageOverridable() {
        // On vérifie si contexte est sur la HomePage ou une popin
        if (window !== window.top) {
            return jQuery("body", window.top.document).hasClass("HomePage")
        }
        else {
            return jQuery("body").hasClass("HomePage");
        }
    }
    _canTestConnectionOverridable() {
        return !isiApp.ajaxRequestInProgress;
    }

    /**
    * @description permet de rendre la fonction modifWaitStatus(visible, wait, codeLibelleStatus) accessible pour normea
    * @param {Boolean} visible
    * @param {Boolean} wait
    * @param {Constante} codeLibelleStatus valeur du WAITING_FAM
    */
    _setModifWaitStatusOverridable(visible, wait, codeLibelleStatus) {
        modifWaitStatus(visible, wait, codeLibelleStatus);
    }

    /**
    * Désactive le voile d'attente sur le beforeUnload
    * @param disable
    */
    _disableModifWaitStatusAutoOnUnloadOverridable(disable) {
        this._disableAutoWaitStatusOnBeforeUnload = disable;
    }

    /**
     * Retourne _disableAutoWaitStatusOnBeforeUnload
     * @returns
     */
    getDisableAutoWaitStatusOnBeforeUnload() {
        return this._disableAutoWaitStatusOnBeforeUnload;
    }

    /**
    * @description Permet de sucharger le code exécuté à la fin du DOMContentLoaded
    */
    _domContentLoadedCompleteOverridable() {

    }

    /**
     * On rédéfinit la valeur de la rupture grande, si on a une valeur personnalisé de la largeur d'écran en RWD
     * @returns number
     */
    ruptureGrand() {
        if (isiApp) {
            return +isiApp.screen.rwdWidth || this.getOptions().ruptureGrand;
        } else {
            return this.getOptions().ruptureGrand;
        }
    }
    //}




    //export class IsiScreenCore {
    _state: IsiDtoIwsUIClientState;
    _structure: IsiDomStructure;
    _actionRedirect: IsiActionRedirect;
    _interaction: IsiInteraction;
    _controlToolBar = null;
    _isiPopin = null;
    _currentScreen: IsiIWSScreen;
    _pagePopin: IsiIWSPopin<any, any>; // Popin de type IsiIWSPopin (ce n'est pas le composant)
    _associatedView: IsiIWSAssociatedView;
    _isiPerformance: IsiPerformance;
    _gridDragNDropManager: IsiGridDragNDropManager;
    /**
     * L'objet IsiiUICore a été créé ?
     */
    _uiCoreCreated: boolean;

    /**
     * Callbacks a appeler une fois IsiUICore (uiCore) créé
     */
    _whenUICoreCreatedHandlers: Function[];

    /**
     * Callbacks a appeler une fois IsiApplication (isiApp) créé
     */
    _whenIsiAppCreatedHandlers: Function[];

    _associatedViewManager: IsiDetailManager;
    _gridManager: IsiGridManagerNewGrid;
    _menuManager: IsiMenuManager;
    _formManager: IsiFormManager;
    _autoRefresh: IsiAutoRefresh;

    constructor(options, parent?: IsiIwsUICore) {
        super(options, parent);
        this._actionRedirect = new IsiActionRedirect();
    }

    getOptions() {
        return <IIsiDtoIwsUI>super.getOptions();
    }

    openGlob(typeName: string, dto: any): Promise<any> {
        return new Promise((resolve: (string) => void, reject) => {
            getPopinArgs(typeName).then((popin) => {
                resolve(popin.fromJS(dto));
            })
        });
    }

    closePopin(): void {
        uiCore.setSubmit(false);
        uiCore.getCurrentPopin().close({
            state: 'abort'
        });
    }
    /**
     * intialisation du gestionnaire de darg n drop.
     */
    initGridDragNDrop() {
        this._gridDragNDropManager = new IsiGridDragNDropManager();
        this._gridDragNDropManager.init();
    }
    initializeOverridable() {
        if (window.clientState) {
            this._state = IsiDtoIwsUIClientState.fromJS(clientState);
        }
        this._structure = new IsiDomStructure();
        this._interaction = new IsiInteraction();
        this._currentScreen = new IsiIWSScreen(false);
        this._isiPerformance = new IsiPerformance();

        this.initGridDragNDrop();
        this.initMousePosition();


        window.isiApp = new IsiApplication();
        this.afterIsiAppCreated();

        //this._currentScreen = jQuery.extend(this._currentScreen, (this.getOptions() as any).screen);

        this._isiPopin = null; // popin type composant
        this._whenUICoreCreatedHandlers = [];
        this._whenIsiAppCreatedHandlers = [];

        //TODO GBAU
        if (this.getOptions().cursorState) {
            this.setCursorState(this.getOptions().cursorState);
        }

        if (this.getOptions().syncCollapseScreenList) {
            window.syncCollapseScreenList();
        }

        this._gridManager = new IsiGridManagerNewGrid(this.getOptions().gridManagerSettings, this._state?.gridManager);

        this._formManager = new IsiFormManager(this._state?.formManager);

        this._associatedViewManager = this.currentScreen.createInstanceOfAssociatedViewManager(this._state?.associatedViewManager);
        // initialisation du gestionnaire de grille.

        if (this.getOptions().menuManagerSettings) {
            this._menuManager = new IsiMenuManager(this.getOptions().menuManagerSettings, this._state?.menuManager);//
        }

        if (this.getOptions().autoRefreshSettings) {
            this._autoRefresh = new IsiAutoRefresh(this.getOptions().autoRefreshSettings, '');
        }

        //if (window.menuEntriesById) {
        //    this.menuManager.setEntriesById(window.menuEntriesById);
        //    this.menuManager.setEntriesIdByClientId(window.menuEntriesIdByClientId);
        //    this.menuManager.setEntriesIdByBarAndKey(window.menuEntriesIdByBarAndKey);
        //}

        //On déclenche l'initialisation de la structure afin de récupérer les références sur les éléments du DOM
        this.structure.init();
        this._uiCoreCreated = true;

        //Appel a iDcp pour définir les controles
        this.defineCtrl();

        //GBAU - 06/08/2019 - On déclanche le chargement du menu DA
        this.whenComponentManagerFound((componentManager: IsiComponentManager) => {
            if ((this.getOptions() as any).bindSwitchMode) {
                uiCore._bindSwitchMode();
            }

            //window.IsiComponentManager = componentManager;
            if (window.isiIwsComponentsAppOnLoad) {
                window.isiIwsComponentsAppOnLoad();
            }

            componentManager.whenComponentInitialized<any>("associatedViewFormVerticalMenu", (cp) => {
                if (uiCore.currentScreen.getCurrentScreenVerticalViewMenuCollapseState()) {
                    cp.collapse();
                } else {
                    cp.pinMenu();
                    cp.unfold();
                }
                cp.runLoad();
            });

            // si le menu master est trouvé on s'abonne au click de la toolbar
            uiCore.whenFormHeaderFound((header) => {

                this._whenHeaderFoundHandler(header, "mm");

            });

            // Si le menu de la DA est trouvé on s'abonne au click de la toollbar de la DA
            screenCore.associatedViewManager.whenHeaderFound((header) => {

                this._whenHeaderFoundHandler(header, "md");

            });

        })

        //Si des callbacks sont enregistrés, on les appele
        if (this._whenUICoreCreatedHandlers && this._whenUICoreCreatedHandlers.length > 0) {
            this._whenUICoreCreatedHandlers.forEach(function (callback) {
                callback();
            });
        }

        this.setStateCtrlColor();

        if (window.serverAfterUICoreCreated) {
            window.serverAfterUICoreCreated();
        }

        if (this.getOptions().screen && this.getOptions().screen.typeScript) {
            //require(["Business/" + this.getOptions().screen.typeScript.substr(0, this.getOptions().screen.typeScript.length - 3)], function (module) {
            //    let screenCode = uiCore.getOptions().screen.father;
            //    if (!screenCode) {
            //        screenCode = uiCore.getOptions().screen.name;
            //    }
            //    if (screenCode) {
            //        uiCore.currentScreen = new module[screenCode]();
            //        uiCore.loadCurrentScreen();
            //    }
            //});

            //jQuery(document.body).append('<script type="importmap-shim">{"imports": {"Isilog.ui.core": "Isilog.ui.core.js"}}</script>');

            if (uiCore.getOptions().screen.typeScript) {
                screens.getScreen(uiCore.getOptions().screen).then(async (screen) => {
                    screen.init(getUICoreSettings().screen);
                    uiCore.currentScreen = screen;
                    await uiCore.loadCurrentScreen();
                });

            }
            //uiCore.currentScreen = new screens[screenCode]();
            //uiCore.loadCurrentScreen();

            //window.importShim(IsiComponentManager.getInstance().get_ScriptsFolderUrl() + "/business/" + this.getOptions().screen.typeScript.substr(0, this.getOptions().screen.typeScript.length - 3) + ".js")
            //    .then((module) => {
            //        let screenCode = uiCore.getOptions().screen.father;
            //        if (!screenCode) {
            //            screenCode = uiCore.getOptions().screen.name;
            //        }
            //        if (screenCode) {
            //            uiCore.currentScreen = new module[screenCode]();
            //            uiCore.loadCurrentScreen();
            //        }
            //    });
        } else {
            this.loadCurrentScreen();
        }
        this.refreshFormDockedBar();
    }

    /**
     * Définit les ctrl dans l'iwsAllCtrl.
     * */
    public defineCtrl() {
        for (var i in window.iDcps) {
            window.iDcp(window.iDcps[i]);
        }
        window.iDcpsBc.forEach((value: any) => {
            const bsCtrl = iwsAllCtrls.getCtrl(value.id);
            bsCtrl.setOriginalSizes(value.sizes);
        });
    }
    /**
     * Fonction permettant de créer une itemlist.
     * */
    public createItemList(source: any[]) {
        return new IsiItemList(source);
    }
    /**
     * Arrête le timer de  l'autorefresh de la page/da.
     * */
    public ClearAutoRefresh() {
        if (this._autoRefresh) {
            this._autoRefresh._clearTimer();
        }
    }

    /**
     * Demande l'autorefresh pour une vue associée
     * @param associatedViewContext
     */
    public RegisterAssociatedViewAutoRefresh(associatedViewContext: IsiIWSAssociatedViewContext, idMenu: string) {

        if (associatedViewContext && !this._autoRefresh) {
            const screenType = this.isTabularView() ? IsiScreenType.VT : IsiScreenType.VA;
            const autoRefresh: IIsiDtoAutoRefreshSettings = IsiDtoAutoRefreshSettings.fromJS({ period: associatedViewContext.associatedViewState.autoRefreshPeriod, type: screenType })

            this._autoRefresh = new IsiAutoRefresh(autoRefresh, idMenu);
        }
    }

    private async loadCurrentScreen() {
        // On renseigne l'écran sur le formulaire courant
        if (this._formManager) {
            this._formManager.currentScreen = uiCore.currentScreen;
        }

        uiCore.currentScreen.load();

        isiApp.screen = uiCore.currentScreen;//new IsiScreen();
        isiApp.onload();
        isiApp.downloadState();

        //Ceci n'est valable que dans le contexte d'execution de la page principale
        if (window != window.top) {
            screenCore.windowPopinOnload();

        } else {
            await this._onScreenLoadEnd();
        }

        if (GetWaitStatus() && !uiCore.associatedViewManager.isShowing() && uiCore.getElasticComponent() && !this._submitPending) {
            modifWaitStatus(false, false, screenCore.getWaitLabel());
        }
        if (window.domContentLoadedCompleteOverridable) {
            window.domContentLoadedCompleteOverridable();
        }
    }

    /**
     * Vérifie si le voile d'attente doit être désactivé,
     * si oui le désactive.
     */
    public disableWaitIfNeeded() {
        if (!this._submitPending && (!uiCore.getElasticComponent() || (uiCore.getElasticComponent() && !uiCore.getElasticComponent().isWaitingScreenNeeded()))) {
            modifWaitStatus(false, false, "");

        }
    }

    /**
     * Traitements en fin de chargement, pour tous les écrans
     */
    private async _onScreenLoadEnd() {

        if (uiCore.currentScreen.isCurrentScreenNotTypeScripted) {
            // Si l'écran n'est pas migré en ts, on fait l'ancien appel direct à window_onload
            if (window.window_onload) {
                window.window_onload();

            }
        } else {
            // Cette partie est l'équivalent de l'ancien "window_onload"

            // si l'écran est en ts, on appel les fonctions de fin de chargement ici
            InitOnLoad();
            // Inserer IMPERATIVEMENT tout le code a effectuer dans cette fonction entre les fonctions 'InitOnLoad' et 'EndOnLoad'
            EndOnLoad();

            // Traitements en fin de chargement, pour les écrans migrés en TS seulement           
            await this._tsScreenLoadEnd();

        }


    }

    /**
     * Traitements en fin de chargement, pour les écrans migrés en TS seulement
     */
    private async _tsScreenLoadEnd() {

        screenCore.currentScreen.domContentLoadedComplete(); // en particulier, ajout des onchanges sur les contrôles

        screenCore.currentScreen.checkEnableSparkle();

        if (window.serverScreenLoadedCompleted) {
            window.serverScreenLoadedCompleted();
        }

        await screenCore.currentScreen.screenLoadedComplete();
    }

    beforeDoPostBackOnBlueLinkOrGreenArrow(sNameCtrl: string) {
        iws_BeforeDoPostBackOnBlueLinkOrGreenArrow();
        return this.currentScreen.beforeDoPostBackOnBlueLinkOrGreenArrow(sNameCtrl);
    }

    get state() {
        return this._state;
    }

    get structure(): IsiDomStructure {
        if (!this.isTop) return this.parent.structure;
        return this._structure;
    }

    get interaction(): IsiInteraction {
        if (!this.isTop) return this.parent.interaction;
        return this._interaction;
    }

    get associatedViewManager(): IsiDetailManager {
        if (!this.isTop) return this.parent.associatedViewManager;
        return this._associatedViewManager;
    }

    get gridManager(): IsiGridManagerNewGrid {
        if (!this.isTop) return this.parent.gridManager;
        return this._gridManager;
    }
    get formManager(): IsiFormManager {
        if (!this.isTop) return this.parent.formManager;
        return this._formManager;
    }
    /**
     * Renvoi le gestionnaire de dragndrop de la grille.
     */
    get gridDragNDropManager(): IsiGridDragNDropManager {
        return this._gridDragNDropManager;
    }

    /**
     * Obtient le gestionnaire de menus
     */
    get menuManager(): IsiMenuManager {
        if (!this.isTop) return this.parent.menuManager;
        return this._menuManager;
    }

    get currentScreen(): IsiIWSScreen {
        if (!this.isTop) return this.parent.currentScreen;
        return this._currentScreen;
    }

    set currentScreen(value: IsiIWSScreen) {
        if (!this.isTop) {
            this.parent.currentScreen = value; return;
        }
        this._currentScreen = value;
    }
    get currentPagePopin(): IsiIWSPopin<any, any> {
        if (!this.isTop) return this.parent.currentPagePopin;
        return this._pagePopin;
    }

    get performance(): IsiPerformance {
        return this._isiPerformance;
    }

    set currentPagePopin(value: IsiIWSPopin<any, any>) {
        if (!this.isTop) {
            this.parent.currentPagePopin = value; return;
        }
        this._pagePopin = value;
    }

    /**
     * Permet d'abonner un callback une fois l'objet IsiUICore (uiCore) créé
     */
    whenUICoreCreated(callback: Function) {
        if (this._uiCoreCreated) {
            callback();
        } else {
            this._whenUICoreCreatedHandlers.push(callback);
        }
    }

    /**
     * Permet d'abonner un callback une fois l'objet IsiApplication (isiApp) créé
     */
    whenIsiAppCreated(callback: Function) {
        if (isiApp) {
            callback();
        } else {
            this._whenIsiAppCreatedHandlers.push(callback);
        }
    }

    afterIsiAppCreated() {
        isiApp.screen = this.currentScreen;//new IsiScreen();

        if (this._whenIsiAppCreatedHandlers && this._whenIsiAppCreatedHandlers.length > 0) {
            this._whenIsiAppCreatedHandlers.forEach(function (callback) {
                callback();
            });
        }
    }

    /**
     * @description Cette méthode permet de s'abonner au click de la toolbar d'un header
     * @param header 
     * @param bar
     */
    _whenHeaderFoundHandler(header: any, bar: string) {

        header.add_onToolbarClicked(function (sender, args) {
            screenCore.menuManager.openMenu(bar, args.group, args.value);
        });
    }

    isTabularView() {
        if (!this.isTop) return this.parent.isTabularView();
        return jQuery(document.body).hasClass("LIST002");
    }



    setLoadInProgress(value) {
        ///<summary>Fonction qui permet de définir que le chargement d'un traitement est encours </summary>
        if (uiCore) {
            uiCore.setSessionStorageItem('loadInProgress', value);
        }
    }
    getLoadInProgress() {
        ///<summary>Fonction qui permet de savoir que le chargement d'un traitement est encours</summary>
        var inProgress = uiCore.getSessionStorageItem('loadInProgress');
        if (inProgress == null) {
            inProgress = false;
            if (uiCore) {
                uiCore.setSessionStorageItem('loadInProgress', inProgress);
            }
        } else {
            inProgress = JSON.parse(inProgress);
        }
        return inProgress;
    }
    setShortcutDisable(value) {
        ///<summary>Fonction qui permet d'activer ou non les raccourcis </summary>
        if (uiCore) {
            uiCore.setSessionStorageItem('shortcutDisable', value);
        }
    }
    getShortcutDisable() {
        ///<summary>Fonction qui permet de récupérer l'état des raccourcis</summary>
        var disa;
        if (uiCore) {
            disa = uiCore.getSessionStorageItem('shortcutDisable');
        }
        if (disa == null) {
            disa = false;
            if (uiCore) {
                uiCore.setSessionStorageItem('shortcutDisable', disa);
            }
        } else {
            disa = JSON.parse(disa);  //JSON.Parse on renvoi un booleen
        }
        return disa;
    }
    getControlToolBar() {
        ///<summary>Fonction qui permet de récupérer la controleToolbar</summary>
        if (!this._controlToolBar && this.componentManager) {
            this._controlToolBar = this.componentManager.getComponent("controlToolbar");
        }
        return this._controlToolBar;
    }
    getIsiPopin() {
        if (!this.isTop) return this.parent.getIsiPopin();
        ///<summary>Fonction qui permet de récupérer la controleToolbar</summary>
        if (!this._isiPopin && this.componentManager) {
            this._isiPopin = this.componentManager.getComponent("isiPopin");
        }
        return this._isiPopin;
    }

    createIsiPopinTooltipInitializer(isHierarchical: boolean, isHtml: boolean, tooltipContent: string) {
        return new IsiPopinTooltipInitializer(isHierarchical, isHtml, tooltipContent);
    }

    setWaitLabel(value) {
        ///<summary>Fonction qui permet de définit le dernier message afficher sur le message d'attente</summary>
        if (uiCore) {
            uiCore.setSessionStorageItem('waitLabel', value);
        }
    }
    getWaitLabel() {
        ///<summary>Fonction qui permet de récupérer le dernier message afficher sur le message d'attent</summary>
        if (uiCore) {
            return uiCore.getSessionStorageItem('waitLabel');
        } else {
            return undefined;
        }
    }
    setCursorState(value) {
        ///<summary>Fonction qui permet de récupérer l'état du curseur</summary>
        if (uiCore) {
            uiCore.setSessionStorageItem('cursorState', value);
        }
    }
    getCursorState() {
        ///<summary>Fonction qui permet de définir l'état du curseur</summary>
        if (uiCore) {
            return uiCore.getSessionStorageItem('cursorState'); //JSON.Parse on renvoi un entier
        } else {
            return null;
        }
    }
    getAttachmentDefaultFilenameOverridable() {
        return screenCore.currentScreen.getAttachmentDefaultFilenameOverridable();
    }
    getCurrentScreenCode() {
        return isiApp.screen.pageName;
    }
    getCurrentLanguage() {
        return CURRENT_LANGUAGE;
    }
    setTitleScreen(title) {
        /// <summary>
        /// title: Titre que l'on veut donner à l'écran IWS
        /// </summary>
        /// <history>
        ///		 <entry mat="LLGU" date="20/12/2016" task="121904">Création</entry>
        /// <history>
        uiCore.getFormHeader().setTitle(title);
    }
    setImageScreen(image) {
        /// <summary>
        /// image: Image que l'on veut donner à l'écran IWS
        /// </summary>
        /// <history>
        ///		 <entry mat="LLGU" date="20/11/2016" task="121904">Création</entry>
        /// <history>
        let fontFamillyClass;
        if (image.startsWith("fi")) {
            fontFamillyClass = "fi";
        } else if (image.startsWith("fa")) {
            fontFamillyClass = "fa";
        }
        jQuery("#FormHeader >.iconContainer").children().attr("class", fontFamillyClass + " " + image);
    }
    getDockBarButton(idButton) {
        return jQuery("#IsiButtonBarForm_" + idButton + "_b");
    }
    closeScreen(event) {
        this.menuManager.openMenuById(MNU_MASTER + MNU_SEP + FORM_MNUGRP_NAVIGATION + MNU_SEP + MenuItemCode.FORM_CLOSE);
    }
    closeDetail(event) {
        this.menuManager.openMenuById(MNU_DETAIL + MNU_SEP + DATA_MNUGRP_NAVIGATION + MNU_SEP + MenuItemCode.DATA_CLOSE);
    }

    /**
     * Méthode lors du clic sur le bouton "Modifier les filtres" sur la VT
     */
    editFilters() {
        this.menuManager.openMenuById(MNU_DETAIL + MNU_SEP + DATA_MNUGRP_NAVIGATION + MNU_SEP + MenuItemCode.EDIT_FILTERS);
    }

    /** Déclenche l'enregistrement du formulaire */
    saveScreen() {
        this.menuManager.openMenuById(MNU_MASTER + MNU_SEP + FORM_MNUGRP_NAVIGATION + MNU_SEP + MenuItemCode.FORM_VALIDATE);
    }

    /** Déclenche l'annulation du formulaire */
    cancelScreen() {
        this.menuManager.openMenuById(MNU_MASTER + MNU_SEP + FORM_MNUGRP_NAVIGATION + MNU_SEP + MenuItemCode.FORM_CANCEL);
    }
    /**
     * Retour le dto de l'action associée à un menu
     * */
    getUiActionFormMenu(menu: IIsiDtoMenuObject, itemId: string): IIsiDtoIwsUIAction {
        return this._getItem(menu, itemId)
    }
    _getItem(oItem: IIsiDtoMenuObject, sItemID: string): IIsiDtoIwsUIAction {
        var item: IIsiDtoIwsUIAction = {
            key: "",
            group: "",
            id: "",
            data: [],
            menuBarId: "",
            menuGroupId: "",
            menuItemId: "",
            codeItemList: "",
            addDetailOnForm: false, // Indique si l'on ajoute dans un detail par le menu du formulaire.
            detailName: "",
            isActionForm: false, //GBAU - 18/01/2012 - Permet de savoir si c'est une action formulaire
            option: "",
            instanceName: ""
        };

        var htmlElement: HTMLElement;
        // On stock dans un controle l'element du menu qui vient d'etre selectionne
        if (oItem) {
            if (oItem instanceof HTMLElement) {
                htmlElement = oItem;
            }
        } else {
            htmlElement = document.getElementById(sItemID)
        }

        if ((oItem && oItem.bar) || (htmlElement && jQuery(oItem).data("bar"))) {
            let id: string;
            if (oItem.bar) {
                item.menuBarId = oItem.bar;
                item.key = oItem.key;
                item.group = oItem.group;
                item.option = oItem.optionUrl;
                if (oItem.data) {
                    item.detailName = oItem.data.detailCode;
                    item.instanceName = oItem.data.instanceCode;
                }
                id = oItem.id;
            } else {
                // GELA - 2011.05.13 - [DEV:43167] : l'attribut Key n'est pas disponible en IE9
                item.menuBarId = jQuery(htmlElement).data("bar");
                item.key = jQuery(htmlElement).data("key");
                item.group = jQuery(htmlElement).data("groupkey");
                item.option = jQuery(htmlElement).data("optionurl");
                item.detailName = jQuery(htmlElement).data("detailname");
                item.instanceName = jQuery(htmlElement).data("instancename");
                id = jQuery(htmlElement).attr("id");
            }

            if (item.instanceName) {
                item.addDetailOnForm = item.instanceName != "";
                item.codeItemList = item.detailName + "|" + item.instanceName;
            }

            item.menuGroupId = item.group;
            item.menuItemId = item.key;
            if (item.group === FORM_ASSOCIATEDVIEW_GROUP && item.instanceName) {
                item.id = item.menuBarId + MNU_SEP + item.group + MNU_SEP + item.detailName + MNU_SEP + id;
            } else {
                item.id = item.menuBarId + MNU_SEP + item.group + MNU_SEP + id;
            }

        } else {
            //  "mm##ASSOCIATEDVIEW_GROUP##PARC001L##ADD_ITEM##PARC001_MATINFO"
            let id: string;
            id = sItemID.replace("PageHeader_", "");
            id = id.replace("DetailHeader_", "");
            item.data = id.split(MNU_SEP);
            if (item.data.length > 3) {
                item.key = item.data[3];
            } else {
                item.key = item.data[2];
            }
            item.group = item.data[1];

            var aData = item.data;
            item.menuGroupId = aData[1];

            // TGUE - 12/08/2009 - DEV15069 - Si on est sur un sous menu, 
            // la position de l action est decale dans le tableau
            if (aData.length > 4) {
                if (aData[3]) {
                    item.menuItemId = aData[3];
                    item.detailName = aData[2];
                    item.menuBarId = MNU_DETAIL
                    // CEGO - 2010.10.22 - [DYSFCT:0000039576] : Determination du codeItemList.
                    if (aData[4]) {
                        item.instanceName = aData[4];
                        item.codeItemList = aData[2] + "|" + aData[4];
                    }
                    else {
                        item.codeItemList = aData[2] + "|" + aData[3];
                    }
                } else {
                    // VLEB - 2011.03.17 - [Dysf:0000042237]
                    item.codeItemList = aData[2];
                }
            }
            else {
                item.menuBarId = aData[0];
                item.menuItemId = aData[2];
                item.codeItemList = aData[2];
            }

            //
            // CEGO - 2010.10.22 - [DYSFCT:0000039576] : Determination du codeItemList.
            item.addDetailOnForm = (aData.length > 4 && aData[4]);

            item.id = id;
        }


        return item;
    }
    /**
     * Lance une dtouiAction directement.
     * @param dto
     */
    LaunchActionUi(dto: IIsiDtoIwsUIAction) {
        var actionContext = new IsiActionContext();
        actionContext.event = null;
        actionContext.uiAction = dto;
        uiCore._launchSubmit(actionContext);
    }
    /**
     * Fonction permettant de créer un context d'action vierge
     * */
    public createActionContext(): IsiActionContext {
        return new IsiActionContext();
    }
    public getActionRedirect() {
        return this._actionRedirect;
    }

    onClick(oItem: IIsiDtoMenuObject, sItemID: string, oEvent?) {
        if (!this.isTop) return this.parent.onClick(oItem, sItemID, oEvent);
        var actionContext = new IsiActionContext();
        actionContext.event = oEvent;
        actionContext.menu = oItem;
        actionContext.menuId = sItemID;

        this.uiActionClicked(actionContext);
    }
    /**
     * On set le context de l'action courrante notamment pour setter l'information sur l'openArgs d'une popin plutard.
     * Attention pas d'accès public interdit!
     **/
    setCurrentActionContext(actionContext: IsiActionContext) {
        this._currentActionContext = actionContext;
    }
    /**
     * Initialise les information lié au context de l'action pour la popin
     * */
    initPopinActionContext(args: IIsiDtoGLOBXXXOpenArgs) {
        if (!args.actionContextId) {
            args.actionContextId = this._currentActionContext?.uiAction?.id;
        }
        if (!args.associatedviewContextId) {
            args.associatedviewContextId = this._currentActionContext?.associatedViewContext?.id;
        }
        this.setCurrentActionContext(null);
    }

    uiActionClicked(actionContext: IsiActionContext) {
        if (!this.isTop) return this.parent.uiActionClicked(actionContext);

        if (actionContext.uiAction == null && (actionContext.menu !== null || actionContext.menuId != "")) {
            actionContext.uiAction = this._getItem(actionContext.menu, actionContext.menuId);
        }

        this.setCurrentActionContext(actionContext);

        // Si j'ai une popin de création - Dysf75191
        if (this.getCurrentPopin() != null) {
            if (this.getCurrentPopin().getBlockingTreatmentId() != "Err-NOT_EXIST_BUT_CAN_EXIST") {
                // On clear
                this.clearTreatments();
            }
        } else {
            // Sinon on clear
            this.clearTreatments();
        }

        //ARAN 29/09/2009 [DYSF31409]Lorsque l'on lance la recherche via le raccourci clavier, il faut valider
        //la fenetre de recherche avance si elle est presente.
        // [LBRI] - 2011.02.02 - [PERF] : on ne fait le getElementById que s'il est necessaire.
        if (actionContext.uiAction.menuItemId == LAUNCHSEARCHv2) {
            var oExtSearchWindow = document.getElementById("DivFullExtSearchContainer");
            if (oExtSearchWindow && oExtSearchWindow.style.display === "block") {
                iws_ValidateExtSearch();
            }
        }
        //TGUE - 13/11/2009 - [DYSF32945] - On lance le Onchange du controle precedement selectionner.
        //ARAN - 10/12/2009 - [DYSF33282] - Si provocateOnChange renvoit un message d'erreur on doit alors bloquer.
        //la validation du formulaire.
        this.setSubmit(provocateOnChange());

        this.confirmLostModif(actionContext, null, null, {
            context: this,
            func: (result) => {
                if (result == "PostWithoutSave") {
                    if (actionContext.uiAction.group?.startsWith("DATA_")) {
                        this._onClickMenuDetail({ result: true, continue: true }, actionContext, event).then((onClickMenuDetailResult) => {
                            uiCore.setSubmit(onClickMenuDetailResult.continue);
                            this._launchSubmit(actionContext);
                        });
                    } else {
                        switch (actionContext.uiAction.menuBarId) {
                            case MNU_MASTER:
                            case DIV_LEFT: // GBAU - POPIN : ???
                                if (actionContext.uiAction.menuBarId == MNU_MASTER || actionContext.uiAction.menuBarId == DIV_LEFT) {
                                    this._onClickMenuMaster(actionContext, event).then((onClickMenuMasterResult) => {
                                        uiCore.setSubmit(onClickMenuMasterResult.continue);
                                        this._launchSubmit(actionContext);
                                    })
                                        .catch((o) => { uiCore.setSubmit(false); });
                                } else {
                                    alert("erreur pas le bon id entre DATA_ et FORM_ !");
                                }
                                break;

                            case MNU_MODULE:
                                this._onClickMenuModule(actionContext.uiAction, event);
                                this._launchSubmit(actionContext);
                                break;

                            case MNU_PAGE:
                                this._onClickMenuPage(actionContext.uiAction, event);
                                this._launchSubmit(actionContext);
                                break;
                            case MNU_EXT_NEWS:
                                this._onClickMenuExtendedNews(actionContext.uiAction, event);
                                this._launchSubmit(actionContext);
                                break;
                        }
                    }
                } else {
                    iws_stopPropagation(actionContext.event);

                    // JBUI - 26/04/2012 - DSYF49453 : on active les raccourcis
                    setShortCutStatus(true);
                    return false;
                }
            },
            id: "uiCore.confirmLostModif callback"
        });

        this.executeRemainingTreatments();
        return false;
    }

    /**
     * Méthode à appelée avant tout submit du formulaire ou de la page
     * @param actionContext
     */
    public beforeSubmit(actionContext?: IsiActionContext) {
        if (actionContext) {
            this._flushActionContextBeforeSubmit(actionContext);
        }

        this.flushClientState();
    }


    private _launchSubmit(actionContext: IsiActionContext) {

        let item = actionContext.uiAction;
        // On annule l'AutoPostBack pour cet evennements javascript du menu
        iws_stopPropagation(item);
        //ARAN 02/12/2020 [PB0021276]Bloquage de la validation si l'écran n'a pas le droits de modification
        let doSubmit: boolean;
        doSubmit = uiCore.getSubmit();

        if (item.key === FORM_VALIDATEv2 || item.key === FORM_VALIDATE_RETURNv2) {
            //Si l'écran n'a pas les droit d'ajout, on force l'annulation du submit
            // HGAN - 29/03/2021 -PB0021541 L'utilisateur connecté n'avait pas la possibilité d'ajouter un enregistrement si le droit de modification de formulaire sur son profil est désactivé.
            if (!uiCore.formManager.canModify && uiCore.getCursorState() !== CURSOR_STATE_ADD) {
                doSubmit = false;
            }
        }

        //si des règles métier ou des onChange de ctrl sont en cours, on met le submit en attente
        if (this.needCheckBusinessRuleRunning() && (this.hasBusinessRuleRunning() || window.xmlUserSettings.IsDefaultValueTriggerOnChange())) {
            doSubmit = false;
            modifWaitStatus(true, true, window.sCodeLibelleStatus);
            this._submitPending = true;
            this._submitPendingActionContext = actionContext;
            this.log("Le submit est mis en attente jusqu'à ce que toutes les règles métiers aient fini de s'exécuter.");
        } else {
            this.setNeedCheckBusinessRuleRunning(true);
        }

        if (doSubmit) {
            this.beforeSubmit(actionContext);
            this.log("Déclenchement du submit");
            // ORIC - 060613 - [DYSF 11512] : Si on demande une vue associee, alors on indique qu'on veut afficher un detail au detailManager.
            // TGUE - 12/08/2009 - DEV15069 - On ne doit pas tester si on a cliquer sur un menu ajouter
            // GELA - 22/06/2011 - [DEV:43894] - On autorise certaines vues associees dans le groupe de menu Outils
            if (item.menuGroupId == MNUGRP_ASSOCIATEDVIEW
                || item.key == UPDATES_LIST
                || item.key == OPEN_SIGNATUREv2) {
                this.associatedViewManager.showNextSubmit();
            }

            // Appel de la fonction surchargeable juste avant le postback.
            iws_BeforeDoPostBack();

            // On affichera le DIV d'attente que dans les cas ou le repostage est long.
            modifWaitStatus(true, true, window.sCodeLibelleStatus);

            // on est oblige de retarder le PostBack pour que tous les autres evennements
            // javascript(comme le onchange sur les controles) soient pris en comptes.
            setTimeout("isiPostBack('" + item.menuBarId + "', '" + item.menuItemId + "')", 100);

            // JBUI - 26 / 04 / 2012 - DSYF49453 : on desactive les raccourcis
            setShortCutStatus(false);

            // OARD - 2007.01.15 - [DYSF:17000] : On n'efface pas les variables liees au submit si on fait un submit.
            window.bAlreadySubmit = true;

        } else {
            this.log("Annulation du submit");

            // JBUI - 26/04/2012 - DSYF49453 : on reactive les raccourcis
            setShortCutStatus(!this._submitPending);
            // OARD - 2007.01.15 - [DYSF:17000] : On n'efface pas les variables liees au submit si on fait un submit.
            if (!window.bAlreadySubmit) {
                // ORIC - 060608 - [DYSF 12759] : Il n'y a pas de submit, on vide donc les champs caches 
                // contenant les menus ou on a clique.
                (<HTMLInputElement>document.getElementById("ihdItemClick")).value = "";
                (<HTMLInputElement>document.getElementById("ihdMenuBarClick")).value = "";
                (<HTMLInputElement>document.getElementById("ihdItemClickForInstance")).value = "";
                (<HTMLInputElement>document.getElementById("ihdItemListClick")).value = "";
            }
            if (item.isActionForm) {
                afterActionFormulaire(item.key);
            }
            //JSOU 27/06/2016 Dysf74911 - Les traitements sont termines, on repasse le submit a True
            this.setSubmit(true);
        }
    }
    flushClientState() {
        jQuery("#ihdClientState").val(JSON.stringify(IsiDtoIwsUIClientState.fromJS(this.state)));
    }
    _flushActionContextBeforeSubmit(actionContext: IsiActionContext) {
        this._state.uiActionId = actionContext.uiAction.id;
        if (actionContext.associatedViewContext) {
            this._state.uiActionContextId = actionContext.associatedViewContext.id;
        }
    }

    private _beforeClickMenuMasterOrDetail(actionContext: IsiActionContext, event) {
        let item = actionContext.uiAction;



        (<HTMLInputElement>document.getElementById("ihdMenuBarClick")).value = item.menuBarId;

        // TGUE - 12/08/2009 - DEV15069 - Ajout des menus en liste 
        // Si on a cliquer sur un menu Ajouter de la liste dune vue associee
        if (item.addDetailOnForm) {
            //(<HTMLInputElement>document.getElementById("ihdItemClickForInstance")).value = item.instanceName;
            // On sauvegarde laction cliquer sur dans la liste dun menu specfique
            (<HTMLInputElement>document.getElementById("ihdItemListClick")).value = item.id;
            // On sauvegarde la vue associee
            (<HTMLInputElement>document.getElementById("ihdItemClick")).value = item.detailName;
            // TGUE - 28/08/2009 - DYSF30162 - on desactive l'appel de l'evt en cascade
            iws_stopPropagation(event);

        } else {

            // On sauve l'action effectuee
            if (item.menuItemId == UPDATES_LIST) {
                item.menuItemId = "GLOB004LSUIVI";
            } else {
                if (item.menuItemId == OPEN_SIGNATUREv2) {
                    item.menuItemId = "PARC096L";
                }
            }
            (<HTMLInputElement>document.getElementById("ihdItemClick")).value = item.menuItemId;
            (<HTMLInputElement>document.getElementById("ihdItemClickOption")).value = item.option;
            (<HTMLInputElement>document.getElementById("ihdItemClickForInstance")).value = "";
            (<HTMLInputElement>document.getElementById("ihdItemListClick")).value = "";
            (<HTMLInputElement>document.getElementById("ihdIsInstanceFormClicked")).value = "false";
        }

        //=========================================================================================================================
        // TODO - [GELA] - [21.02.2013] - [ANA:PB0006893] - Lorsque l'on realise des actions, Les modifications en cours sur le dossier sont perdues (DYSF40444). 
        // Dans le cas ou le client a clique sur annule dans la popup de confirmation
        // la fonction iws_ConfirmLostModif retournera la valeur "NoPostBack"
        // Il ne faut pas faire les traitements before ci-dessous 
        //=========================================================================================================================


        // vide le code pour ne pas effectue de recherche si
        // aucuns code n'est renseigner pour la status bar
        window.sCodeLibelleStatus = "";
        //ARAN 14/01/2009 - DEV20502 - Avant de realiser le traitement on pose une question a l'utilisateur dans certaint condition
    }

    private _onClickMenuMaster(actionContext: IsiActionContext, event): Promise<IIsiUIFlowResult> {
        this._beforeClickMenuMasterOrDetail(actionContext, event);
        return this._formManager.uiActionClicked(actionContext);
    }

    private _onClickMenuDetail(flow: IIsiUIFlowResult, actionContext: IsiActionContext, event): Promise<IIsiUIFlowResult> {
        this._beforeClickMenuMasterOrDetail(actionContext, event);
        return this.associatedViewManager.uiActionClicked(flow, actionContext);
    }
    private _onClickMenuModule(item, event) {
        var bSubmit = false;
        switch (item.menuItemId) {
            case ModuleAdmin:
            case ModuleAssetManag:
            case ModuleHelpDesk:
            case ModuleInvent:
            case ModuleAudit:
                if ((<HTMLInputElement>document.getElementById("ihdCurrentItemmnuModule")).value != item.menuItemId) {
                    (<HTMLInputElement>document.getElementById("ihdItemClickmnuModule")).value = item.menuItemId;
                    uiCore.setSubmit(true);
                } else {
                    uiCore.setSubmit(false);
                }
                break;
            default:
                uiCore.setSubmit(true);
                break;
        }

        /*if (bSubmit) {
            // YLAR On teste la présence du composant bench
            isiApp.startBench("Page");
     
            onclickItem(sItemclick + '_' + sCodeModule);
            poster();
        }*/
    }
    private _onClickMenuPage(item, event) {
        iSCtrlClk(MNU_PAGE, null, event);
        // On recupere l'Id du menu selectionne
        (<HTMLInputElement>document.getElementById("ihdItemClickmnuPage")).value = item.menuItemId;
    }
    private _onClickMenuExtendedNews(item, event) {
        iSCtrlClk(MNU_EXT_NEWS, null, event);
        (<HTMLInputElement>document.getElementById("ihdItemClickmnuPage")).value = item.menuItemId;
    }
    confirmLostModif(actionContext: IsiActionContext, isTrv, trvDataKey, callbackTreatmentArgs) {
        const confirmation = new IsiConfirmation();
        confirmation.LaunchConfirmation(actionContext, isTrv, trvDataKey, callbackTreatmentArgs);
    }


    getScreenInstance() {
        return new ScreenTest(this);
    }
    getIwsSessionId() {
        var pihdSessionId = <HTMLInputElement>document.getElementById("ihdIwsSessionId");
        var iwsSessionId;
        if (pihdSessionId) {
            iwsSessionId = pihdSessionId.value;
            pihdSessionId = null;
        }
        return iwsSessionId;
    }
    /**
     * Permer d'afficher la barre dockée du formulaire (et donc masquer la barre dockée de la vue associée)
     */
    showFormDockedBar() {

        const formDockedBar = jQuery("#" + BUTTONBARFORM);

        //if (formDockedBar.css("display") == "none") {
        if (!(formDockedBar.hasClass("empty"))) {
            formDockedBar.show();
        }

        jQuery(this._currentAssociatedViewDockedBar).hide();
        this.hideAssociatedViewBgmAndShowFormMenu();
        this._currentAssociatedViewDockedBar = null;
        this.refreshFormDockedBar();
        //}
    }

    refreshFormDockedBar() {
        const idDockedBar = this.isTouchMode() ? BUTTONBARFORMSCROLLVIEW : BUTTONBARFORM;
        const formDockedBar = jQuery("#" + idDockedBar);
        const dockedBarSettings = this.getOptions().dockedBarFormSettings;

        if (!(formDockedBar.hasClass("empty") && formDockedBar.is(":visible"))) {
            let numberElementInDockedBar = 0;

            formDockedBar.children(".containerDock").each(
                (index: number, element: HTMLElement) => {
                    const children = jQuery(element).children(".control.IsiButton");
                    if (!children.hasClass("xnv")) {
                        if (numberElementInDockedBar < dockedBarSettings.nbMaxActionBar || dockedBarSettings.listIdButtonIgnoreNbMax.includes(element.id) || this.isTouchMode()) {
                            numberElementInDockedBar++;
                            //Il faut d'abord faire un .hide sinon il peut il y avoir des problèmes de rendu sur chrome
                            jQuery(element).hide().show(0);
                        } else {
                            jQuery(element).hide();
                        }
                    }
                });
        }

    }

    /**
    * Permer d'afficher le burger menu de la vue associée (et donc masquer le burger menu du formulaire)
    */
    showAssociatedViewBgm(gridViewId: string) {
        jQuery(`#burgerMenuContainer>#${gridViewId}bgmC`).show();
        jQuery(`#burgerMenuContainer>div:not(#${gridViewId}bgmC)`).hide();

    }
    /**
    * Permer de cacher le burger menu de la vue associée (et donc d'afficher le burger menu du formulaire)
    */
    hideAssociatedViewBgmAndShowFormMenu() {
        jQuery(`#burgerMenuContainer>.screenMenuContainer`).show();
        jQuery(`#burgerMenuContainer>div:not(.screenMenuContainer)`).hide();
    }

    /**
     * Permer d'afficher la barre dockée de la vue associée (et donc masquer la barre dockée du formulaire)
     */
    showAssociatedViewDockedBar() {


        if (this._currentAssociatedViewDockedBar) {
            this._currentAssociatedViewDockedBar.hide();
        }

        let id = "md";
        if (this.associatedViewManager.currentContext) {
            id = this.associatedViewManager.currentContext.id + id;
        }

        var associatedViewDockedBar;
        associatedViewDockedBar = jQuery("#" + BUTTONBARDETAIL + id);

        jQuery("#" + BUTTONBARFORM).hide();
        if (!(associatedViewDockedBar.hasClass("empty"))) {
            associatedViewDockedBar.show();
            this._currentAssociatedViewDockedBar = associatedViewDockedBar;
        }

    }
    dockedBarHeight() {
        if (this.hasDockedBar() && (jQuery(this._currentAssociatedViewDockedBar).is(":visible") || jQuery("#" + BUTTONBARFORM).is(":visible"))) {
            return parseInt(jQuery("#" + BUTTONBARFORM).css("height"));
        }
        return 0;
    }
    hasDockedBar() {
        return !(jQuery("body").hasClass("noDockedBar"));
    }
    getAssociatedView() {
        return this.componentManager.getComponent("AssociatedView");
    }
    isAssociatedViewScrollFocus() {
        //if (uiCore && uiCore.isRWD() && uiCore.isTouchMode() && this._switchDockedBarOnScroll && this.structure.divDetail.exists()) {
        //    if (this.associatedViewManager.currentContext) {
        //        if (this.structure.divDetail.offset().top - jQuery(window).scrollTop() < jQuery(window).height() / 2) {
        //            return true;
        //        }
        //    }
        //}
        return false;
    }
    isAssociatedViewMode() {
        return jQuery("body").hasClass("associatedViewFocused");
    }
    isFormMode() {
        return jQuery("body").hasClass("formFocused");
    }
    showForm() {
        jQuery("body").removeClass("associatedViewFocused").addClass("formFocused");
    }
    showAssociatedView() {
        jQuery("body").removeClass("formFocused").addClass("associatedViewFocused");
    }
    registerOnload(fn: Function) {
        isiApp.registerOnload(fn);
    }
    registerOnUnload(fn: Function) {
        isiApp.registerOnUnload(fn);
    }

    beforeConfirmLostModifShowPopin(item?): Promise<boolean> {
        return this.currentScreen.beforeConfirmLostModifShowPopin(item);

    }

    beforeActionOnDetail(actionContext: IsiActionContext) {
        this.currentScreen.beforeActionOnDetail(actionContext);
    }


    getWpCriteria() {
        return this.componentManager.getComponent("wpCriteria");
    }

    windowPopinOnload() {


        if (this.currentPagePopin) {
            this.currentPagePopin.windowPopinOnload();
        } else {
            window.window_onload();
        }

    }

    afterChooseInstance(actionContext: IsiActionContext): boolean {
        afterChooseInstance_Overridable();
        return screenCore.currentScreen.afterChooseInstance(actionContext);
    }

    isScreenWithGrid() {
        return (isiApp.screen.name == "LIST003" || isiApp.screen.name == "GLOB005");
    }

    /*-- CREATION -----------------------------------------------------------------------------
    '- Auteur      : TGUE
    '- Date        : 18/02/2010
    '- Description : [DEV31267] - On va checker les validator
    '-----------------------------------------------------------------------------------------*/
    iws_checkValidators() {
        var bSubmit = true;
        if (typeof (Page_Validators) !== "undefined") {
            // Si on a des validators
            if (Page_Validators) {
                // Si 1 des validator est faut, on arrete le traitement
                for (var i = 0; i < Page_Validators.length; i++) {
                    ValidatorValidate(Page_Validators[i]);
                    if (!Page_Validators[i].isvalid) {
                        bSubmit = false;
                        var ctrlID = Page_Validators[i].id.substring(Page_Validators[i].id.length - MASK_EDIT_VALIDATOR.length - 1, 0);
                        var oCtrl = document.getElementById(ctrlID + '_' + TEXTBOX);
                        if (oCtrl) {

                            // On vide la variable stockant l'action en cours. Sinon, lorsque l'on change de langue,
                            // on reposte la page et donc on lance l'action valider alors que tous les champs 
                            // obligatoires n'etaient pas remplit.
                            var ihdItemClick = <HTMLInputElement>document.getElementById("ihdItemClick");
                            if (ihdItemClick) {
                                ihdItemClick.value = "";
                            }
                            // On positionne le focus sur le premier element.
                            iws_SetFocus(ctrlID + '_' + TEXTBOX);
                        }
                    }
                }
            }
        }
        return bSubmit;
    }

    protected createInstanceOfPopInSettingsOverridable<TOpenArgs, TCallbackArgs>(args: IIsiPopInSettingsConstructorArgs<TOpenArgs, TCallbackArgs>) {
        return new IsiIwsPopInSettings<TOpenArgs, TCallbackArgs>(args);
    }

    /**
     * Permet d'attacher un événement de clic sur le bouton de traduction
     * @param iCtrl le contrôle potentiellement traductible
     */
    public bindGlob068Opening(iCtrl: IwsControle) {
        const tradButton = jQuery(iCtrl.getElement()).find('.tradButton').length === 0 ?
            jQuery(`#${iCtrl.clientId}_ibtr`) :
            jQuery(iCtrl.getElement()).find('.tradButton');

        if (tradButton.length !== 0) {
            tradButton.on('click', () => {
                this.openSimpleTranslatePopin(iCtrl);
            });
        }
    }

    /**
     * Ouvre la popin de traduction simple pour un contrôle.
     * @param iCtrl
     */
    public openSimpleTranslatePopin(iCtrl: IwsControle) {
        GLOB068().open(IsiDtoGLOB068OpenArgs.fromJS({
            ctrlCode: iCtrl.id,
            ctrlName: iCtrl.getLabelElement().textContent.trim() ?? iCtrl.datafieldValue,
            isEnabled: !iCtrl.disabled,
            ctrlClientId: iCtrl.fullId,
            ctrlDataField: iCtrl.datafieldValue,
            enregSign: iwsAllCtrls.getCtrl('ihdC_SIGNATURE').value(),
            ctrlMaxLength: iCtrl.getInputElement().maxLength,
            ctrlRows: Number(jQuery(`#${iCtrl.clientId}_t`).attr('rows')) || 0,
            isFromAdmWebPart: false,
            ctrlWidth: uiCore.isRWD() ? jQuery("#" + iCtrl.fullId).outerWidth() : jQuery("#" + iCtrl.fullId).width()
        }));
    }

    /**
     * Ouvre la popin de traduction simple pour un web part.
     * @param wpObj
     */
    public openSimpleTranslatePopinForWebPartOveridable(wpObj: any) {
        GLOB068().open(IsiDtoGLOB068OpenArgs.fromJS({
            ctrlCode: wpObj.row.data().key,
            ctrlName: wpObj.row.children('.IsiCellLabel').children('.label').text() ?? wpObj.row.data().key,
            isEnabled: true,
            ctrlClientId: wpObj.cell.attr('id'),
            ctrlDataField: 'VA_WPCLIENTPARAM',
            enregSign: wpObj.row.data().sign,
            ctrlMaxLength: 255,
            ctrlRows: 0,
            isFromAdmWebPart: true,
            ctrlWidth: 300 // pour les webparts on sera toujours à la taille minimal pour la popin donc on met une taille fixe.
        }));
    }

    /**
     * Permet d'ouvrir la popin de traduction sur un contrôle riche.
     * @param iCtrl le contrôle potentiellement traductible
     * @param mode le mode d'affichage de la popin (riche / brute)
     */
    public tryOpenRichTranslatePopin(iCtrl: IwsControle, mode: string) {
        if (iCtrl?.ctrlType != ControlTypes.CTRL_ISIMEMO)
            return;

        GLOB069().open(IsiDtoGLOB069OpenArgs.fromJS({
            ctrlCode: iCtrl.id,
            ctrlDataField: iCtrl.datafieldValue,
            fieldLabel: iCtrl.getLabelElement().textContent.trim() ?? iCtrl.datafieldValue,
            fieldEnabled: !iCtrl.disabled,
            fieldMode: mode ?? IsiFW.Components.Editor.Enumerable.editMode.plaintext,
            enregSign: iwsAllCtrls.tryGetFieldValue("ihdC_SIGNATURE"),
        }));
    }

    /*-- CREATION -----------------------------------------------------------------------------
    '- Auteur      : LBRI
    '- Date        : 27/11/2007
    '- Description : Modifie la couleur des controles en fonction de l'etat du curseur.
    '-----------------------------------------------------------------------------------------*/
    setStateCtrlColor() {
        var mode = this.getCursorState();

        switch (mode) {
            case CURSOR_STATE_SEARCH:
                // Recherche
                break;
            case CURSOR_STATE_ADD:
            //Ajout
            case CURSOR_STATE_UPDATE:
            //Modification
            case CURSOR_STATE_CONSULT:
            //Consultation
            case CURSOR_STATE_LOCK:
            //Reserve pour Edition
            case CURSOR_STATE_DUPLICATE:
                //Duplication
                iwsAllCtrls.MandatoryCtrlColorManagement();
                break;
            default:
                break;
        }

    }

    _specificPageSizeOverridable() {
        const self = this;
        setTimeout(function () {
            if (self.ruptureGrand() > self.getOptions().ruptureGrand) {
                self._sizeChanged();
            }
        }, 0)
    }

    buildAjaxUrl(url) {
        var pihdSessionId = jQuery("#ihdIwsSessionId");
        let iwsSessionId;
        if (pihdSessionId) {
            iwsSessionId = pihdSessionId.val();
            pihdSessionId = null;
        }

        url = addOrReplaceParamToUrl(url, "IwsId", iwsSessionId);

        return url;
    }

    initMousePosition() {
        jQuery(document).on("mousemove", (event: JQuery.MouseMoveEvent) =>
            this.updateMousePosition(event.clientX, event.clientY));
    }

    /**
     * Met à jour les coordonnées du pointeur de la souris
     * @param coordX
     * @param coordY
     */
    updateMousePosition(coordX: number, coordY: number) {
        this._positionMouseX = coordX;
        this._positionMouseY = coordY;
    }

    /**
     * Vérfie si la souris est positionnée sur un élément
     * @param element
     * @returns
     */
    checkMouseOverElement(element: HTMLElement) {
        const coordElement = element.getBoundingClientRect();
        const isMouseOver = (
            this._positionMouseX >= coordElement.left &&
            this._positionMouseX <= coordElement.right &&
            this._positionMouseY >= coordElement.top &&
            this._positionMouseY <= coordElement.bottom
        );
        return isMouseOver;
    }

    getMousePosition() {
        return { mouseX: this._positionMouseX, mouseY: this._positionMouseY }
    }

    /**
     * Ajoute une règle métier en cours dans la collection
     * @param ruleName
     */
    addBusinessRuleRunning(ruleName: string) {
        if (!this._businessRulesRunning) {
            this._businessRulesRunning = [];
        }

        this._businessRulesRunning.push(ruleName);
    }

    /**
     * Supprime une règle métier de la collection des règles métiers en cours
     * @param ruleName
     */
    removeBusinessRuleRunning(ruleName: string) {
        if (this._businessRulesRunning) {
            const index = this._businessRulesRunning.indexOf(ruleName);
            if (index !== -1) {
                this._businessRulesRunning.splice(index, 1);
                if (this._businessRulesRunning.length === 0) {
                    this.launchSubmitIfPending()
                }
            }
        }
    }

    /**
     * Indique si une règle métier est en cours
     * @returns
     */
    hasBusinessRuleRunning(): boolean {
        if (this._businessRulesRunning && this._businessRulesRunning.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Renseigne l'option de vérification de la règle métier
     * @param needCheckBusinessRuleRunning
     */
    setNeedCheckBusinessRuleRunning(needCheckBusinessRuleRunning: boolean) {
        this._needCheckBusinessRuleRunning = needCheckBusinessRuleRunning;
    }

    /**
     * Indique s'il faut vérifier si une règle métier est en cours lors du submit
     * True par défaut mais permet d'etre contourné (par exemple si champ obligatoire non renseigné on sait qu'on ne va pas submit)
     * @returns
     */
    needCheckBusinessRuleRunning(): boolean {
        return this._needCheckBusinessRuleRunning
    }

    /**
     * exécute l'action qui a déclenché un submit qui a été mis en attente
     */
    launchSubmitIfPending() {
        if (this._submitPending && this._submitPendingActionContext) {
            this._submitPending = false;
            const menuId = this._submitPendingActionContext.menuId;
            if (menuId) {
                this.menuManager.openMenuById(menuId);
            } else {
                this.LaunchActionUi(this._submitPendingActionContext.uiAction);
            }
        }
    }

    disableUnhandledRejectionHandler() {
        _disableUnhandledRejectionHandler();
    }

    unableUnhandledRejectionHandler() {
        _unableUnhandledRejectionHandler();
    }

    screenAllowDrag() {
        return this.currentScreen.allowDrag();
    }
}

/**
 * Méthode permettant de constuire l'url d'ouverture d'une popiun
 * @returns string
 */
export class IsiIwsPopInSettings<TOpenArgs, TCallbackArgs> extends IsiPopInSettings<TOpenArgs, TCallbackArgs> {

    constructor(args) {
        super(args);
    }
    /**
    * On renseigne les informations du 
    * @param args Les args
    * @param options les options
    */
    protected _beforeOpenOverridable(args?: TOpenArgs, options?: IIsiPopInSettingsOpenSettings<TOpenArgs, TCallbackArgs>) {
        let xxxArgs = <IIsiDtoGLOBXXXOpenArgs>args;
        if (xxxArgs) {
            uiCore.initPopinActionContext(args)
        }
    }

    buildUrlOverridable = function (options, urlArgs) {
        let url = "../";
        let folder;
        if (jQuery(document.body).hasClass("HomePage")) {
            url = "Pages/";
        }
        if (this.getCode().indexOf("GLOB") != -1) {
            folder = "Global";
        } else if (this.getCode().indexOf("HELP") != -1) {
            folder = "HelpDesk";
        } else if (this.getCode().indexOf("PARC") != -1) {
            folder = "Parc";
        } else if (this.getCode().indexOf("ADM") != -1) {
            folder = "Admin";
        } else if (this.getCode().indexOf("AUDIT") != -1) {
            folder = "Audit";
        } else if (this.getCode().indexOf("DIAG") != -1) {
            folder = "Diag";
        } else if (this.getCode().indexOf("PLAN") != -1) {
            folder = "Planning";
        }
        url = url + folder + '/' + this.getCode() + '.aspx';

        if (urlArgs !== null && urlArgs !== '' && urlArgs !== undefined) {
            url = url + '?' + urlArgs;
        }
        return appendSessionId(url);
    }
}

export class IsiIWSScreenSettings {
    specificPageResizeGridSettings: IsiIWSScreenSpecificPageResizeGridSettings;
}

export class IsiIWSScreenSpecificPageResizeGridSettings {
    contBoundaries: string;
    divSelection: string;
    divScreenDescirption: string;
    divMain: string;
}

interface IIsiFromJsable<T extends IsiDataTransferObject> {
    fromJS(data?: any): T;
}

interface InstanciableDTO<T extends IsiDataTransferObject> extends IIsiFromJsable<T> {
    new(data?: IIsiDataTransferObject): T;
}

export class IsiIWSPopin<TOpenArgs, TCallbackArgs> {

    public readonly afterXml = IsiFieldEvent.afterXml;

    private _settings: IsiIwsPopInSettings<TOpenArgs, TCallbackArgs>;
    // Pl des popins
    private _pl: IsiPlPopin;

    constructor() {
        this._pl = new IsiPlPopin();
    }
    /**
     * Permet de récupérer les paramètre ouvrant de la popin
     * @param type
     */
    protected OpeningArgs<T extends IsiDataTransferObject>(type: InstanciableDTO<T>): TOpenArgs {
        const params = new URLSearchParams(window.location.search);
        if (params.has("args")) {
            return type.fromJS(JSON.parse(params.get("args"))) as unknown as TOpenArgs;
        } else {
            return null;
        }
    }

    /**
     * Fonction appelée sur l'initialisation de la popin (une fois le chargement du script et la création de l'instance de la popin)
     */
    public init(settings: IsiIwsPopInSettings<TOpenArgs, TCallbackArgs>) {
        this._settings = settings;
        this.initOverridable();
    }

    /** 
     * permet de retourner des instance personnalisé sur la GLOB019
     */
    public getInstance(): Promise<IsiIWSPopin<unknown, unknown>> {
        return new Promise((resolve: (screen: IsiIWSPopin<unknown, unknown>) => void): void => {
            resolve(this);
        });
    }
    /**
     * Fonction appelée sur l'initialisation de la popin (une fois le chargement du script et la création de l'instance de la popin)
     * à surcharger dans la classe de la page de test.
     * */
    protected initOverridable() {

    }

    /**
     * Soumet la popin après l’évaluation de toutes les valeurs def.
     * @param action
     */
    public validateAfterAllValDefReady(action: () => any) {
        if (window.xmlUserSettings.IsRelatedCalculationInProgress()) {
            const handler = () => {
                action()
                window.xmlUserSettings.unsubscribe(EVENT_AFTER_CALC_VAL_DEF, handler)
            }
            window.xmlUserSettings.subscribe(EVENT_AFTER_CALC_VAL_DEF, handler)
        } else {
            action()
        }
    }


    /**
     * Attache un évènement personalisé à un contrôle Iws
     * @param ctrl
     * @param event
     * @param delegate
    */
    protected on(ctrl: string, event: string, delegate: (elem: any, args: any) => void) {
        const cev = new IsiFieldEvent();
        cev.on(ctrl, event, delegate);
    }

    /**
    * bind un event change sur une combo
    * @param ctrlName nom du IwsControle
    * @param func fonction de gestion du changement et c'est maitenant ! 
    */
    protected bindChange(ctrlName: string, func: any) {
        const ctrlMsgType = iwsAllCtrls.getCtrl(ctrlName)
        if (ctrlMsgType) {
            jQuery("#" + jQuery.escapeSelector(ctrlMsgType.clientId + SEP_ENCAPS_CTRL + TEXTBOX)).bind("change", func)
        }
    }
    /**
    * bind un event change sur une combo
    * @param ctrlName nom du IwsControle
    * @param func fonction de gestion du changement et c'est maitenant ! 
    */
    protected bindKeyUp(ctrlName: string, func: any) {
        const ctrlMsgType = iwsAllCtrls.getCtrl(ctrlName)
        if (ctrlMsgType) {
            jQuery("#" + jQuery.escapeSelector(ctrlMsgType.clientId + SEP_ENCAPS_CTRL + TEXTBOX)).bind("keyup", func)
        }
    }

    /**
     * Interception du KeyPressed sur le document.
     * @param evt l'event
     * @param keyCode le code de la touche frappée
     * @param ret booléen de retour indiquant si le traitement doit continuer.
     */
    protected DocumentKeyPressedOverridable(evt: any, keyCode: number, ret: boolean) {
        const ctrl = evt.ctrlKey ? true : false;

        // cas du Ctrl+H pour la duplication d'enregistrement
        if (ctrl && keyCode === 72) {
            ret = false
        }

        // cas du Ctrl+o pour la déconnection de l'appli
        if (ctrl && keyCode === 79) {
            ret = false;
        }

        // cas du Ctrl+K pour l'ouverture d'elastic
        if (ctrl && keyCode === 75) {
            ret = false;
        }

        return ret;
    }


    /**
     * Fonction qui retourne la IsiIwsPopInSettings de la popin
     * */
    protected getSettings(): IsiIwsPopInSettings<TOpenArgs, TCallbackArgs> {
        return this._settings;
    }
    windowPopinOnload() {
        this.windowPopinOnloadOverridable();
    }

    protected windowPopinOnloadOverridable() {

    }

    /** Méthode buttonClicked qui prend un callback et qui l'éxecute sur le click du bouton
     * /!\ ATTENTION : cette méthode ne s'abonne qu'une seule fois sur le bouton, dans le cas où le bouton ne ferme pas la popin 
     * (exemple : vérif de champs non renseignés), il faudra réappeler cette méthode
     * @param id
     * @returns
     */
    protected buttonClicked(id: string): Promise<JQuery<HTMLInputElement>> {
        return new Promise((resolve) => {
            let elem = jQuery("#" + id + " #b");
            // Si le bouton n'est pas de type isiButton, on recherche l'identifiant du bouton 
            if (elem.length === 0) {
                elem = jQuery("#" + id);
            }
            if (elem.length === 0) {
                elem = jQuery("[name='" + id + "$b']");
            }
            elem.on("click", function () {
                resolve(<JQuery<HTMLInputElement>>jQuery(this));
            });
        });
    }

    protected get returnValue(): TCallbackArgs {
        return this.getSettings().getReturnValue();
    }

    protected set returnValue(value: TCallbackArgs) {
        this.getSettings().setReturnValue(value);
    }

    /**
     * Permet de nettoyer la session et de transmettre des données à la fermeture d'une popin
     * @param closingParams
     */
    protected async closePopinWithSessionCleaning(closingdlg: () => any): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            this._pl.cleanSessionInfos().then((result) => {
                if (result.continue) {
                    uiCore.getCurrentPopin().close(closingdlg());
                    resolve({ result: true, continue: true })
                } else {
                    reject(result);
                }
            });
        });
    }
}

export class IsiFieldEvent {

    public static afterXml = "isiAfterXml";
    /**
 * Attache un évènement personalisé à un contrôle Iws
 * @param ctrl
 * @param event
 * @param delegate
 */
    public on(ctrl: string, event: string, delegate: (elem: any, args: any) => void) {
        const c = this._getCtrlInput(ctrl);
        const me = this;
        if (c && c.length > 0) {
            c.on(event, (elem, args) => {
                delegate.apply(me, [elem, args]);
            });
        } else {
            // on trace parce que ce n'est pas normal de ne pas trouver le contrôle !
            uiCore.logError("Le contrôle \"" + ctrl + "\" n'existe pas, il ne sera pas possible de lui ajouter l'évènement \"" + event + "\" !");
        }
    }

    /**
      * Donne la zone de saisie du contrôle spécifié
      * @param ctrl
      * @returns
      */
    private _getCtrlInput(ctrl: string) {
        let jCtrllColumn = null;
        const ctrlColumn = iwsAllCtrls.getCtrl(ctrl);
        if (ctrlColumn) {
            jCtrllColumn = jQuery(ctrlColumn.getInputElement());
        }
        return jCtrllColumn;
    }
}

export class IsiIWSScreen<T extends IsiDataTransferObject = IsiDataTransferObject> {

    type;
    table;
    _detailName;
    name;
    useContext;
    pageName;
    accessType;

    public readonly afterXml = IsiFieldEvent.afterXml;
    public readonly iwsAllCtrls: IwsPage = iwsAllCtrls;

    private _settings: IsiIWSScreenSettings;

    private _useTypeScript: boolean = true;

    private _stateId: string = null;

    private _isiCia: IsiCia;
    /**
     * Délégué sur un traitement métier afin de pouvoir lancer un traitement différent de l'appel standard
     */
    protected _buisnessTreatmentDlg: (key: string) => Promise<IIsiUIFlowResult> = null;

    /**
     * Les paramètres de la page
     * Disponible uniquement si la page a été initialisée avec une classe de DTO
     * Initialisé après que le DOM est été chargé
     */
    protected pageSettings: T | null = null;

    /**
     * @param useTypeScript Classe utilisant le typescript
     * @param pageSettingsClass La classe du DTO à utiliser pour les paramètres de la page
     */
    constructor(useTypeScript?: boolean, private readonly pageSettingsClass: InstanciableDTO<T> | null = null) {
        /// <summary>
        ///  Gestionnaire de l'ecran.
        /// </summary>

        if (typeof useTypeScript !== "undefined") {
            this._useTypeScript = useTypeScript;
        }

        //---------------------------------------------------------------
        // Public members
        //---------------------------------------------------------------
        this.type = IsiScreenType.NonDefinit;
        this.table = "";
        this._detailName = "";
        this.name = "";
        this.useContext = IsiUseContext.full;
        // determine le nom de la page.
        this.pageName = "";
        var _pageName = document.location.pathname;
        if (_pageName != "") {
            var n = _pageName.match(/^(?:\/[^\/]+)*\/([^\/]+)\.aspx$/);
            if (n && n.length == 2) {
                this.pageName = n[1];
            }
        }
    }

    /**
     * Envoie une requête à l’IA via le PL CIA à partir d’un Sparkle donné.
     * Récupère les sources, construit la requête, envoie et affiche la réponse IA.
     * @param sparkleId ID du Sparkle cliqué.
     */
    public async CallIa(ctrlId: string, sparkleId: string) {
        await this._cia.CallIa(ctrlId, sparkleId)
    }

    configure() {
        this._settings = new IsiIWSScreenSettings();
        this.configureOverridable(this._settings);
    }

    /**
     * Lève l'évènement isiAfterXml, à la fin du onchange d'un champ
     * @param id
     */
    public afterOnChange(id, eventDetail) {
        const ctrl = iwsAllCtrls.getCtrl(id);
        // lancement d'un éventuelle évènement sur le contrôle en court de modification
        if (ctrl.canDispatch(this.afterXml)) {

            const eventIsiAfterXml = new CustomEvent(this.afterXml, {
                detail: eventDetail,
            });

            ctrl.getInputElement().dispatchEvent(eventIsiAfterXml);
        }
    }

    /**
     * Retourne un délégué surchargeant un traitement métier standard
     */
    public get buisnessTreatmentDlg(): (key: string) => Promise<IIsiUIFlowResult> {
        return this._buisnessTreatmentDlg;
    }

    protected configureOverridable(settings?: IsiIWSScreenSettings) {

    }

    /**
     * Attache un évènement personalisé à un contrôle Iws
     * @param ctrl
     * @param event
     * @param delegate
     */
    protected on(ctrl: string, event: string, delegate: (elem: any, args: any) => void) {
        const cev = new IsiFieldEvent();
        cev.on(ctrl, event, delegate);
    }

    /**
     * Retourne l'identifiant de l'état de page.
     * **/
    public get StateId() {
        if (this._stateId === null) {
            let jElem = jQuery("#ihdPageState")
            if (jElem.length > 0) {
                this._stateId = <string>jElem.val();
            }
        }
        return this._stateId;
    }
    createInstanceOfAssociatedViewManager(state: IsiDtoAssociatedViewManagerClientState) {
        return new IsiDetailManager(state);
    }

    private get _cia(): IsiCia {
        if (!this._isiCia) {
            this._isiCia = new IsiCia();
        }
        return this._isiCia;
    }

    get isSpecificPageResizeGrid() {
        return this._settings && this._settings.specificPageResizeGridSettings !== undefined;
    }

    get specificPageResizeGridSettings() {
        if (!this._settings) {
            return;
        }
        return this._settings.specificPageResizeGridSettings;
    }
    /*
    * Interception du KeyPressed sur le document.
    * @param evt l'event
    * @param keyCode le code de la touche frappée
    * @param ret booléen de retour indiquant si le traitement doit continuer.
    */
    protected DocumentKeyPressedOverridable(evt: any, keyCode: number, ret: boolean) {
        const ctrl = evt.ctrlKey ? true : false;

        // cas du Ctrl + V pour l'ouverture d'elastic + lancement de recherche en mode suggest
        if (ctrl && keyCode === 86) {

            if (this._isPasteForElastic()) {

                uiCore.componentManager.whenComponentFound<IsiIwsElasticSearch>("elasticBtn_search", (cp) => {
                    navigator.clipboard.readText().then((clipText) => {
                        cp.launchSearchSuggest(clipText);
                    }).catch(() => {
                        uiCore.showErrorMessage(uiCore.getMessage("UICORE", "ClipboardNotAllowed"));
                    });
                });
                ret = false;
            }
        }

        // cas du Ctrl+H pour la duplication d'enregistrement
        if (ctrl && keyCode === 72) {
            ret = false
        }

        // cas du Ctrl+o pour la déconnection de l'appli
        if (ctrl && keyCode === 79) {
            ret = false;
        }

        // cas du Ctrl+K pour l'ouverture d'elastic
        if (ctrl && keyCode === 75) {
            ret = false;
        }

        return ret;
    }

    /**
     * Retourne True si il faut faire le copier dans le bandeau elastic au lieu de l'élément en focus
     * @returns
     */
    private _isPasteForElastic(): boolean {
        const el = iws_activeElement();

        //le contenu du controle RichText est du html donc on va regarder dans les parents si on se trouve dans un RichText
        let isRichTextElt = false;
        if (el && (el.classList.contains('IsiRichTextTextArea') || (jQuery(el).parents('.IsiRichText') && jQuery(el).parents('.IsiRichText').length > 0))) {
            isRichTextElt = true;
        }

        return !el || !(el.tagName.toLowerCase() === 'input' || el.tagName.toLowerCase() === 'textarea' || isRichTextElt || el.classList.contains('paste'));
    }

    //---------------------------------------------------------------
    // Public members
    //---------------------------------------------------------------
    getDetailName() {
        if (this._detailName == "") {
            this._detailName = iws_GetDisplayedAssociatedViewName();
        }
        return this._detailName;
    }
    init(dto: IIsiDtoIwsUIScreen) {
        this.table = dto.table;
        this.type = dto.type;
        this.useContext = dto.useContext;
        this.accessType = dto.accessType;
        this.name = dto.name;
    }
    isClient() {
        return (this.accessType == "AC" || this.useContext == IsiUseContext.client);
    }
    dispose() {
    }

    load() {
        this.configure();
        this.loadOverridable();
    }

    protected loadOverridable() {

    }

    backButtonClick() {
        this.backButtonClickOverridable();
    }

    protected backButtonClickOverridable() {
        // Sur le bouton back, on simule un clique sur fermer. Le bouton n'est pas présent ? Ca ne fera rien
        // Sur chrome, la fonction ne sera pas appelé lors du retour arrière si l'utilisateur n'a pas interagi avec la page
        if (screenCore.isAssociatedViewMode()) {
            screenCore.menuManager.openMenuById("md##DATA_NAVIGATION_GROUP##DATA_CLOSE_ITEM");
        } else if (!uiCore.isHomepage()) {
            Menu_BeforeItemSelected(null, "mm##FORM_NAVIGATION_GROUP##FORM_CLOSE_ITEM", null);
        }
    }

    /**
     * Cette méthode définit si le current screen est migré en ts ou non
     * 
     * */
    get isCurrentScreenNotTypeScripted(): boolean {
        return !this._useTypeScript;
    }

    beforeActionOnFormulaire(item: IIsiDtoIwsUIAction, bc?: IsiBc): Promise<IIsiUIFlowResult> {

        return this._beforeActionOnFormulaireOverridable(item, bc);
    }

    protected _beforeActionOnFormulaireOverridable(item: IIsiDtoIwsUIAction, bc?: IsiBc): Promise<IIsiUIFlowResult> {
        return Promise.resolve({ result: true, continue: true });
    }

    beforeValidateOnFormulaire(): Promise<IIsiUIFlowResult> {
        return this._beforeValidateOnFormulaireOverridable();
    }

    protected _beforeValidateOnFormulaireOverridable(): Promise<IIsiUIFlowResult> {
        return Promise.resolve({ result: true, continue: true });
    }

    beforeAddOnFormulaire(): Promise<IIsiUIFlowResult> {
        return this._beforeAddOnFormulaireOverridable();
    }

    protected _beforeAddOnFormulaireOverridable(): Promise<IIsiUIFlowResult> {
        return Promise.resolve({ result: true, continue: true });
    }

    beforeConfirmLostModifShowPopin(item?): Promise<boolean> {
        return this.beforeConfirmLostModifShowPopinOverridable(item);
    }
    /**
   * Propriété sur une connexe de la page.
   * @param evt
   * @param idObjTxt
   * @param idObj
   * @param imgButtonID
   * @returns
   */
    public onProperty(evt, idObjTxt, idObj, imgButtonID): Promise<boolean> {
        return this.onPropertyOverridable(evt, idObjTxt, idObj, imgButtonID);
    }

    /**
     * Propriété sur une connexe de la page (surchargeable).
     * @param evt
     * @param idObjTxt
     * @param idObj
     * @param imgButtonID
     * @returns
     */
    protected onPropertyOverridable(evt, idObjTxt, idObj, imgButtonID): Promise<boolean> {
        /// <summary>
        ///     Fonction surchargeable lancee au debut de bPropTr (anciennement beginPropertyTreatment).
        ///     Elle permet de bloquer le traitement normal de pPropTr.
        /// </summary>
        return this._defaultPropertyTr(evt, idObjTxt, idObj, imgButtonID);
    }



    /**
     * Propriété sur un connexe du formulaire.
     * CDES T118252
     * CLEM 12/05/2016 T118252 POPIN
     * @param _evt
     * @param idObjTxt
     * @param IdObj
     * @param imgButtonID
     * @returns
     */
    private _defaultPropertyTr(_evt, idObjTxt, IdObj, imgButtonID): Promise<boolean> {
        return new Promise((resolve) => {
            // On affiche la popin que si on a pas de traitement bloquant.
            if (uiCore.getSubmit()) {
                let evaluatedValue: string;

                // Récupère la valeur réelle
                const sValue = (document.getElementById(idObjTxt) as HTMLInputElement).value;
                // Déduction de la valeur d'évaluation
                if (IsEntryOnlyJokers(sValue)) {
                    // La valeur réelle correspond à la saisie de jokers
                    // La valeur d'évaluation utilisée sera donc une chaine vide
                    evaluatedValue = "";
                } else {
                    // Sinon la valeur évaluée est la valeur réelle
                    evaluatedValue = sValue;
                }
                const plInstanceScreen = new IsiPlInstanceScreen;
                plInstanceScreen.GetInstance(uiCore.currentScreen.name, IdObj, evaluatedValue).then((result) => {

                    if (result.result) {
                        if (result.reponse.moreOneInstance) {
                            // On masque le message d'attente, si le confirmLostModif
                            modifWaitStatus(false, false, null);

                            uiCore.setSubmit(false);
                            //Appel la fonction d'ajout
                            this._getInstanceForAdd(IdObj, "AjoutInstance", undefined, (result: string) => {
                                this._retourPopinInstance(result, IdObj, imgButtonID, resolve);
                            });
                        } else if (result.reponse.instanceFormResult) {
                            (document.getElementById('ihdItemClickForInstance') as HTMLInputElement).value = result.reponse.instanceFormResult;
                            resolve(true);
                        } else {
                            resolve(true);
                        }
                    } else {
                        resolve(false);
                    }
                });
            } else {
                resolve(false);
            }
        });
    }

    /**
      * traite le retour de popin de choix d'instance
      */
    private _retourPopinInstance(result: string, idOBj: string, imgButId: string, resolve: (value: boolean | PromiseLike<boolean>) => void) {
        if (result) {
            if (result !== "CANCEL_BY_USER") {
                const propertyTb = uiCore.componentManager.getComponent<any>("controlToolbar");
                if (propertyTb) { // en mode Touch, le bouton propriété est dans un cmoposant
                    propertyTb.launchProperty(iwsAllCtrls.getCtrl(idOBj));
                } else { // en mode desktop, le bouton propriété est dans le connexe
                    isiPostBack(imgButId, null);
                }
            } else {
                // YLAR 20/02/2019 DYSF80013 : Ajout d'une ligne d'historique dans le cas de l'annulation de la sélection d'instance
                history.pushState(null, null, document.URL);
            }
        }
        resolve(uiCore.getSubmit());
    }

    /**
     * Appelle la popup pour selectionner une instance lors de d'un ajout par textconnexe.
     * @param sIDObj
     * @param sTraitement
     * @param sIDCtrl
     * @param callbackTreatment
     */
    private _getInstanceForAdd(sIDObj: string, sTraitement: string, sIDCtrl: string, callbackTreatment) {
        uiCore.addUITreatment({
            func: "getInstanceForAll",
            args: [sIDObj, sTraitement, "ADD", sIDCtrl, IsiCallerType.GreenArrow, callbackTreatment]
        });
    }

    /**
     * Cette méthode est a surcharger au besoin. Elle est appelée avant que le noyau déclenche l'affichage de la popin de confirmation.
     * Pour annuler le traitement de confirmation noyau, il faut faire un uiCore.setSubmit(false);
     **/
    protected beforeConfirmLostModifShowPopinOverridable(item?): Promise<boolean> {
        return new Promise((resolve, reject) => {
            return resolve(true);
        });
    }

    displayConfirmLostModif(allWentOk: boolean) {
        return this._displayConfirmLostModifOverridable(allWentOk);
    }
    /**
    * Fonction virtuelle, surchargée par un écran elle permet à ce dernier de bloquer la pop-in confimrLostModif
    * @returns True: Afficher la pop-in, False: Ne pas afficher la pop-in
    */
    _displayConfirmLostModifOverridable(allWentOk: boolean): boolean {
        return allWentOk;
    }
    /**
     * Cette méthode permet de redimensionner la grille sur des écran spécifique
     * 
     * */
    specificPageResizeGrid() {
        return this.specificPageResizeGridOverridable();
    }

    /**
     * Cette méthode est à surcharger au besoin
     * 
     * */
    protected specificPageResizeGridOverridable() {
        return true;
    }

    /**
    * Traitements à la fin du chargement de l'écran
    * 
    * */
    async screenLoadedComplete() {
        await this.screenLoadedCompleteOverridable();
    }

    /**
    * Cette méthode est à surcharger au besoin
    * 
    * */
    protected async screenLoadedCompleteOverridable() {

    }

    /**
     * Cette méthode permet de réaliser les actions nécessaire lorsque la page est chargé.
     */
    domContentLoadedComplete() {
        // Récupération des paramètres de la page
        if (this.pageSettingsClass !== null) {
            const ihdPageSettings = document.querySelector('#ihdPageSettings');

            if (ihdPageSettings instanceof HTMLInputElement) {
                try {
                    const parsedValue = JSON.parse(ihdPageSettings.value);
                    this.pageSettings = this.pageSettingsClass.fromJS(parsedValue);
                } catch {
                    console.warn("La valeur du contrôle ihdPageSettings n'est pas un JSON valide.");
                }
            } else {
                console.warn("Le contrôle ihdPageSettings n'existe pas ou n'est pas un champ caché");
            }
        }

        this.domContentLoadedCompleteOverridable();
    }
    /**
     * Cette méthode est à surcharger au besoin
     * 
     * */
    protected domContentLoadedCompleteOverridable() {

    }
    /*
     *  Cette méthode permet de définir les actions à réaliser sur la modificaiton de champs
     */
    checkEnableSparkle() {
        const ctrlSparkleVisibility = iwsAllCtrls.getCtrl("itxtSparklesVisibility");
        if (ctrlSparkleVisibility) {
            this._cia.EvalSparkleVisibility(ctrlSparkleVisibility.value())
            // Sur tous les écrans on écoute la modification du champs listant les sparkle à afficher ou masquer
            this.on("itxtSparklesVisibility", this.afterXml, async (elem, args) => {
                this._cia.EvalSparkleVisibility(elem.originalEvent.srcElement.value)
            });
        }
    }
    /**
     * Affecte les valeurs dans les others fields de l'entité avant traitement.
     * 
     */
    public getOtherFieldsForAjaxSyncBuisness(otherFields) {
        this.getOtherFieldsForAjaxSyncBuisnessOverridable(otherFields);
    }

    /**
     * Affecte les valeurs dans les others fields de l'entité avant traitement surchargeable.
     * 
     */
    protected getOtherFieldsForAjaxSyncBuisnessOverridable(otherFields) {

    }
    beforeActionOnFormulaireForAllForm(actionContext: IsiActionContext): Promise<IIsiUIFlowResult> {
        return this._beforeActionOnFormulaireForAllFormOverridable(actionContext);
    }

    protected _beforeActionOnFormulaireForAllFormOverridable(actionContext: IsiActionContext): Promise<IIsiUIFlowResult> {
        return Promise.resolve({ result: true, continue: true });
    }

    resetComboPagination() {
        return this.resetComboPaginationOveridable();
    }
    protected resetComboPaginationOveridable() {

    }

    beforeActionOnDetail(actionContext: IsiActionContext) {
        uiCore.addUITreatment({
            id: "beforeActionOnDetail",
            func: function (me, context) {
                return function () {
                    context.beforeActionOnDetail = me.beforeActionOnDetailOverridable(context);
                }
            }(this, actionContext)
        });
    }

    protected beforeActionOnDetailOverridable(actionContext: IsiActionContext) {
        return true;
    }

    beforeArchiveOnFormulaire(): Promise<IIsiUIFlowResult> {
        return this._beforeArchiveOnFormulaireOverridable();
    }

    protected _beforeArchiveOnFormulaireOverridable(): Promise<IIsiUIFlowResult> {
        return Promise.resolve({ result: true, continue: true });
    }
    onDeleteOnFormulaire(): Promise<IIsiUIFlowResult> {
        /// <summary>
        /// Cette fonction est appelée lorsque la suppression a été valider par l'utilisateur
        /// </summary>
        /// <param name="oItem"></param>
        /// <returns type=""></returns>
        return this._onDeleteOnFormulaireOverridable();
    }

    protected _onDeleteOnFormulaireOverridable(): Promise<IIsiUIFlowResult> {
        /// <summary>
        /// Cette fonction surchargeable est appelée par la fonction <see cref="onDeleteOnFormulaire"></see>.
        /// </summary>
        /// <param name="oItem"></param>
        /// <returns type=""></returns>  
        return Promise.resolve({ result: true, continue: true });
    }

    beforeCancelOnFormulaire(): Promise<IIsiUIFlowResult> {
        return this._beforeCancelOnFormulaireOverridable();
    }

    protected _beforeCancelOnFormulaireOverridable(): Promise<IIsiUIFlowResult> {
        return Promise.resolve({ result: true, continue: true });
    }

    beforeDeleteOnFormulaire(): Promise<IIsiUIFlowResult> {
        return this._beforeDeleteOnFormulaireOverridable();
    }

    protected _beforeDeleteOnFormulaireOverridable(): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            // ARAN 09/07/2009 [DEV25148] Avant de lancer la suppression on demande a l'utilisateur s'il confirme la
            // la suppression 
            // LLGU - 03/03/2016 : PopIn générique de suppression
            uiCore.showConfirm({
                message: uiCore.getMessage("ActionDelete", "SUPPRESS").IsiLabel,
                iconType: IsiIconType.Question,
                confirmMode: IsiModeConfirm.YesNo,
                callback: function (result) {
                    resolve({ result: true, continue: (result === IsiButtonType.Yes) });
                }
            });

        })
    }

    beforeRefreshOnFormulaire(): Promise<IIsiUIFlowResult> {
        return this._beforeRefreshOnFormulaireOverridable();
    }

    protected _beforeRefreshOnFormulaireOverridable(): Promise<IIsiUIFlowResult> {
        return Promise.resolve({ result: true, continue: true });
    }

    // MCHA - 70608 : Avant de lancer la consultation cote serveur, cette fonction surchargeable
    // permet d effectuer d autres traitements.
    beforePropertyOnFormulaire(): Promise<IIsiUIFlowResult> {
        return this._beforePropertyOnFormulaireOverridable();
    }

    protected _beforePropertyOnFormulaireOverridable(): Promise<IIsiUIFlowResult> {
        return Promise.resolve({ result: true, continue: true });
    }


    // CEGO - 2009.05.19 - [TACHE:24896] : Avant de lancer l'archivage cote serveur, cette fonction surchargeable
    // permet d effectuer d autres traitements.
    beforeRestoreOnFormulaire(): Promise<IIsiUIFlowResult> {
        return this._beforeRestoreOnFormulaireOverridable();
    }

    protected _beforeRestoreOnFormulaireOverridable(): Promise<IIsiUIFlowResult> {
        return Promise.resolve({ result: true, continue: true });
    }

    beforeCloseOnFormulaire(): Promise<IIsiUIFlowResult> {
        return this._beforeCloseOnFormulaireOverridable();
    }

    protected _beforeCloseOnFormulaireOverridable(): Promise<IIsiUIFlowResult> {
        return Promise.resolve({ result: true, continue: true });
    }
    CheckCompulsoryFieldsForScreen(item: IIsiDtoIwsUIAction): boolean {
        return this._checkCompulsoryFieldsForScreenOverridable(item);
    }

    protected _checkCompulsoryFieldsForScreenOverridable(item: IIsiDtoIwsUIAction): boolean {
        return true;
    }

    beforeTreatmentBusinessCheckAfterCheckCompulsoryFields(item: IIsiDtoIwsUIAction): Promise<IIsiUIFlowResult> {
        return this._beforeTreatmentBusinessCheckAfterCheckCompulsoryFields(item);
    }

    protected _beforeTreatmentBusinessCheckAfterCheckCompulsoryFields(item: IIsiDtoIwsUIAction): Promise<IIsiUIFlowResult> {
        return Promise.resolve({ result: true, continue: true });
    }
    /**
     * Ajoute dans le localStorage l'écran que l'on vient de désépingler pour qu'il soit plié par défaut
     * @param collapsedState
     */
    setCurrentScreenVerticalViewMenuCollapseState(collapsedState: boolean) {

        const dtoScreensStateList = this.getScreensVerticalViewMenuColapseState();
        if (collapsedState) {
            dtoScreensStateList.push(this.pageName);
        } else {
            const index = dtoScreensStateList.indexOf(this.pageName);
            if (index > -1) {
                dtoScreensStateList.splice(index, 1);
            }
        }
        this.setScreensVerticalViewMenuColapseState(dtoScreensStateList);
    }

    /**
     * récupère la position plié-deplié du menu vertical de l'écran courant stocké dans le localStorage
     */
    getCurrentScreenVerticalViewMenuCollapseState() {
        const dtoScreensStateList: Array<string> = this.getScreensVerticalViewMenuColapseState();
        const index = dtoScreensStateList.indexOf(this.pageName);
        let ret: boolean
        if (index > -1) {
            ret = true;
        } else {
            ret = false;
        }
        return ret;
    }

    /**
  * enregistre la position plié-déplié du menu vertical de l'écran courant dans le localStorage
  * @param nameCtrl
  */
    beforeDoPostBackOnBlueLinkOrGreenArrow(nameCtrl: string): boolean {
        return this.beforeDoPostBackOnBlueLinkOrGreenArrowOverridable(nameCtrl);
    }

    /**
     * enregistre la position plié-déplié du menu vertical de l'écran courant dans le localStorage
     * @param nameCtrl
     */
    protected beforeDoPostBackOnBlueLinkOrGreenArrowOverridable(nameCtrl: string): boolean {
        return true;
    }

    /**
     * enregistre la liste des écrans et la postion plié-déplié de leurs menu vertical dans le localStorage
     * @param dtoScreensCollapseState
     */
    setScreensVerticalViewMenuColapseState(dtoScreensCollapseState: Array<string>) {
        localStorage.setItem("dtoScreensCollapseState", JSON.stringify(dtoScreensCollapseState));
    }
    /**
     * récupère la liste des écrans et la postion plié-déplié de leurs menu vertical stocké dans le localStorage
     */
    getScreensVerticalViewMenuColapseState() {
        let dtoScreensStateList: Array<string> = JSON.parse(localStorage.getItem("dtoScreensCollapseState"));
        if (dtoScreensStateList == null) {
            dtoScreensStateList = [];
        }
        return dtoScreensStateList
    }

    beforeChooseInstance(associatedViewContext: IsiIWSAssociatedViewContext): Promise<boolean> {

        return new Promise<boolean>((resolve, reject) => {
            this.beforeChooseInstanceOverridable(associatedViewContext).then((result) => {
                if (result) {
                    screenCore.associatedViewManager.beforeChooseInstance(associatedViewContext).then((value) => {
                        uiCore.setData("beforeChooseInstance", value);
                        resolve(value);
                    });
                } else {
                    resolve(result);
                }
            });
        })
    }

    protected beforeChooseInstanceOverridable(associatedViewContext: IsiIWSAssociatedViewContext): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            resolve(true);
        })
    }

    afterChooseInstance(actionContext: IsiActionContext): boolean {
        return this.afterChooseInstanceOverridable(actionContext);
    }

    protected afterChooseInstanceOverridable(actionContext: IsiActionContext): boolean {
        actionContext.afterChooseInstance = true;
        return true;
    }

    getAttachmentDefaultFilenameOverridable() {
        return "";
    }

    beforeValidateOnFormulaireAfterCheckCompulsoryFields(actionContext: IsiActionContext): Promise<IIsiUIFlowResult> {
        return this._beforeValidateOnFormulaireAfterCheckCompulsoryFieldsOverridable(actionContext);
    }

    protected _beforeValidateOnFormulaireAfterCheckCompulsoryFieldsOverridable(actionContext: IsiActionContext): Promise<IIsiUIFlowResult> {
        return Promise.resolve({ result: true, continue: true });
    }


    beforeValidateOnFormulaireAfterCheckBusiness(objBc: IsiBc): Promise<IIsiUIFlowResult> {
        return this._beforeValidateOnFormulaireAfterCheckBusinessOverridable(objBc);
    }

    protected _beforeValidateOnFormulaireAfterCheckBusinessOverridable(objBc: IsiBc): Promise<IIsiUIFlowResult> {
        return Promise.resolve({ result: true, continue: true });
    }

    /**
     * Vérifie le format d'une date
     * @param ctrl
     * @param format
     * @returns
     */
    protected async checkDateFormat(ctrl: IwsControle, format) {
        let result = true;
        let mask = ctrl.isiCtrlMask;

        if (mask === "") {
            if (format === "D") {
                mask = "dd/MM/yyyy";
            } else {
                mask = "dd/MM/yyyy HH:mm:ss";
            }
        }

        const plCheckDate = new IsiPlCheckDateFormat();
        result = await plCheckDate.checkDateFormat(ctrl.value(), mask);

        if (!result) {
            // Erreur format date (avec passage en parametre du format attendu)
            let errMsg = getMessagesForJavascript().GetMessage('FormatIncorrect').L_MESSAGE;
            errMsg = errMsg.replace("$i", mask);
            if (errMsg) {
                uiCore.showErrorMessage(errMsg.replace("\\n", "\\015"));
                ctrl.setValueNoChange("");
            }
        }
        return result;
    }

    /**
     * Permet de surcharger le menu que l'on souhaite utiliser dans un écran pour une action
     * @param action
     * @returns
     */
    public getActionMenuOverridable(action): string {
        return null;
    }

    /**
     * Indique si l'écran autorise le drag and drop d'elements externe
     */
    public allowDrag() {
        return false;
    }
}


//var uiCore;
/**
 * Fonction de déserialisation du dtoClient contenant les informations
 * sur le dit client : navigateur...
 * */
function loadDtoClient() {

    this.ihdDtoClient = document.getElementById("ihdDtoClient");
    //Si on a un controle
    if (this.ihdDtoClient && this.ihdDtoClient.value !== "") {
        var dtoClientIWS = jQuery.parseJSON(this.ihdDtoClient.value);
        if (dtoClientIWS.IsiState == 0) {
            dtoClientIWS.IsiHeight.value = isiGetClientHeight();
            dtoClientIWS.IsiWidth.value = isiGetClientWidth();
        }
    } else {
        dtoClientIWS = null;
    }
    return dtoClientIWS;
}

export function initUiCore() {
    //si on est sur une popin alors on reprend la popin de la 
    if (window !== window.parent && typeof (window.parent.uiCore) !== 'undefined' && !jQuery("body").hasClass("slavePage")) {
        initUiCorePopin();

        if (!uiCore.isHomepage()) {
            // SPRI - 14/05/2020 - Dysf90092
            // Instanciation des objets globaux de IsiSuggest (utiliser pour les champs de type connexe)
            initializeIsiSuggestGlobalObjects();
        }
    } else {
        let settings: IIsiDtoIwsUI = getUICoreSettings();
        __webpack_public_path__ = settings.webpackPublicPath;

        window.uiCore = new IsiIwsUICore(settings);
        window.screenCore = window.uiCore;
        window.uiCore.initialize();
        AfterUICoreCreated(window.uiCore);
    }
    return window.uiCore;
}
window.initUiCore = initUiCore;
//document.addEventListener("DOMContentLoaded", function () { initUiCore(); });

function initUiCorePopin() {
    let parentUiCore = <IsiIwsUICore>window.parent.uiCore;

    let settings: IIsiDtoIwsUI = parentUiCore.getOptions();
    __webpack_public_path__ = settings.webpackPublicPath;

    let localCore = new IsiIwsUICore(settings, parentUiCore);

    window.uiCore = localCore;
    window.screenCore = localCore;
    localCore.initialize();
    //permet d'avoir accès aux fonctions presentes dans le scope de la popin
    //localCore.popinUIContext = new IsiPopinUIContext();

    window.isiApp = new IsiApplication();

    //Appel a iDcp pour définir les controles 
    localCore.defineCtrl();

    window.isiApp.screen = parentUiCore.currentScreen;

    // On ne reprend pas la valeur isRWD, car une popin RWD peut être appelé à partir d'un écran vintage.
    //localCore._isRWD = jQuery("body").hasClass("rwd");

    //localCore.popinUIContext.componentManager = localCore.createComponentManager(jQuery("#IsiComponentManager"));
    //localCore.createController(jQuery("#IsiController"));

    //if (localCore.componentManager) {
    //    __webpack_public_path__ = localCore.componentManager.get_ScriptsFolderUrl() + "/dist/";
    //    for (var i in window.IsiCpFns) {
    //        let o: any = window.IsiCpFns[i]();
    //        if (o && typeof o.type !== "undefined") {
    //            localCore.componentFactory.createComponent(o.type, o.id, null, o.props, jQuery("#" + o.id));
    //        }
    //    }
    //}
    if (parentUiCore.getCurrentPopin()._useTs) {
        getPopin(parentUiCore.getCurrentPopin().getCode()).then((popin) => {
            parentUiCore.currentPagePopin = popin;
            popin.init(<IsiIwsPopInSettings<unknown, unknown>>parentUiCore.getCurrentPopin());
        });
    }
    if (window.serverAfterUICoreCreated) {
        window.serverAfterUICoreCreated();
    }
    if (window.afterInitUiCorePopin) {
        window.afterInitUiCorePopin();
    }
    if (window.window_onload) {
        window.window_onload();
    }
    jQuery(window).on("beforeunload", function () {
        uiCore.currentPagePopin = null;
    });

    return localCore;
}
window.initUiCorePopin = initUiCorePopin;

function getUICoreSettings(): IIsiDtoIwsUI {

    var settings: IsiDtoIwsUI = IsiDtoIwsUI.fromJS(window.uiCoreSettings);
    settings = jQuery.extend(settings, {
        detectClient: !jQuery("body").hasClass("slavePage"),
        feedback: {
            anchor: "#feedbackAnchor"
        },
        scrollButton: {
            divContainer: "#DivMaster",
            containerID: window,
            scrollableContainer: jQuery("html, body")
        },
        enableFileDragNDrop: true, //!iws_isHomePage()
        onBackButton: function () {
            // YLAR DEV 134668  : La fonction ''Précédent'' fait ''Fermer''.
            //dans le cas d'une popin on n'exécute pas le bouton fermer
            if (jQuery(".fancybox-iframe").length == 0) {
                uiCore.currentScreen.backButtonClick();
            }
            historyOnBackOverridable();
        }
    });

    // CLEM - Dysf74129 -  gestion des boutons et des traces du graphviz popin
    // On affiche les bouton de graphviz pour les popin que si on est en debug
    // Ces boutons sont désactivés sur la homepage dans homepage.js (configureUICoreSettingsOverridable)
    //TODO GBAU GRILLE : A mettre dans les options pour décoréllé de isiApp
    //settings.isModeDiag = (isiApp.appState && isiApp.appState.debug) || false;

    if (window.configureUICoreSettingsOverridable) {
        window.configureUICoreSettingsOverridable(settings);
    }
    return settings;
}
function _unhandledrejectionEventHandler(event) {
    // the event object has two special properties:
    //alert(event.promise); // [object Promise] - the promise that generated the error
    if (event.reason instanceof IsiUIFlowRejectReason) {
        let reason = <IsiUIFlowRejectReason>event.reason;
        uiCore.showErrorMessage("Unhandled Rejection : " + reason.reason);
    } else {
        uiCore.showErrorMessage("Unhandled Rejection : " + event.reason); // Error: Whoops! - the unhandled error object
    }
}

function _unableUnhandledRejectionHandler() {
    window.addEventListener('unhandledrejection', _unhandledrejectionEventHandler);
}
function _disableUnhandledRejectionHandler() {
    window.removeEventListener('unhandledrejection', _unhandledrejectionEventHandler);
}

function AfterUICoreCreated(uiCore: IsiIwsUICore) {

    _unableUnhandledRejectionHandler();

    // MBRO - 29/08/2017 - DEV 138850
    if (!uiCore.isHomepage()) {
        // Si on est pas sur la page d'accueil (cette page ne gère pas les controles IWS)

        // Instanciation des objets globaux de IsiSuggest (utiliser pour les champs de type connexe)
        initializeIsiSuggestGlobalObjects();

        // Cette intialisation est effectuée ici car uiCore.isTouchMode() est utilisé pour déterminer le type d'instance de ces objets 
        // ET que ces objets doivent être instanciés le plus tôt possible sur la page
        // TODO : Voir si un autre emplacement serait plus approprié ?
    }

    for (var i in window.afterUICoreCreatedDelegates) {
        window.afterUICoreCreatedDelegates[i]();
    }
}



function configureUICoreSettingsOverridable(settings) {
    // CLEM - Dysf74129 -  gestion des boutons et des traces du graphviz popin
    // On affiche les bouton de graphviz pour les popin que si on est en debug
    // Ces boutons sont désactivés sur la homepage dans homepage.js (configureUICoreSettingsOverridable)
    settings.isModeDiag = (isiApp.appState && isiApp.appState.debug) || false;

}

//window.screenCore = new IsiScreenCore();


/**
 * Constructeur de la classe
 * @constructor
 */
function IsiGenericScreen() {

}

export function getScreenInstance() {
    return new IsiGenericScreen();
}
